/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HandlersWindVelocityRecord,
  InputAdminAmmo,
  InputAdminBrigade,
  InputAdminChatChannel,
  InputAdminDivision,
  InputAdminElementCaptureRooms,
  InputAdminElementLogin,
  InputAdminOSG,
  InputAdminOTG,
  InputAdminOTGPolygon,
  InputAdminStockItem,
  InputAdminStockMovement,
  InputAdminStockTransfer,
  InputAdminTeam,
  InputAdminTeamMembers,
  InputAdminUavPlatform,
  InputAdminUavTeamActivation,
  InputAdminUser,
  InputAdminZone,
  InputApproveTeamSession,
  InputAuthToken,
  InputBeginWebAuthnRegistrationRequest,
  InputBeginWebAuthnVerificationRequest,
  InputBroadcastRequest,
  InputBrowsersInfo,
  InputChannelMessageReadStatus,
  InputChatMessage,
  InputChatMessageReaction,
  InputCompleteWebAuthnRegistrationRequest,
  InputCompleteWebAuthnVerificationRequest,
  InputCreateHistoryEvent,
  InputCreateTeamVideoLink,
  InputDeleteWebAuthnCredentialRequest,
  InputDisableTwoFactorRequest,
  InputEditAdminChatChannel,
  InputEditAdminUser,
  InputEnableTwoFactorRequest,
  InputEwSuppressionSessionCreate,
  InputFAQ,
  InputFilePresign,
  InputGeoReverse,
  InputMergeDivisions,
  InputMissionResult,
  InputMissionVideo,
  InputNews,
  InputPosition,
  InputPositionUpdate,
  InputPushToken,
  InputRestartTeamSession,
  InputSaveMissionDrops,
  InputSignalGroupRequest,
  InputStartSession,
  InputSuspiciousUserEvent,
  InputSystemPermission,
  InputTarget,
  InputTargetImport,
  InputUavCrewSettings,
  InputUavMission,
  InputUavMissionFlightParams,
  InputUavMissionFlightPath,
  InputUavMissionLoiterArea,
  InputUavMissionNote,
  InputUavMissionPositionOverride,
  InputUavMissionShootdown,
  InputUavMissionStatus,
  InputUavMissionTemplate,
  InputUavParsePreview,
  InputUpdateHistoryEvent,
  InputUpdateMissionChannels,
  InputUpdatePilotTeamSettings,
  InputUserProfile,
  InputVerifyTotpCodeRequest,
  InputVerifyTwoFactorRequest,
  InputWindLabRequest,
  InputZoneAdminZone,
  InputZoneRequest,
  OutputAdminAmmo,
  OutputAdminBrigade,
  OutputAdminChatChannel,
  OutputAdminDetailedSession,
  OutputAdminDivision,
  OutputAdminElementSession,
  OutputAdminOSG,
  OutputAdminOTG,
  OutputAdminPositionStockResponse,
  OutputAdminRoleSelector,
  OutputAdminSession,
  OutputAdminStockItem,
  OutputAdminTeam,
  OutputAdminTeamsZonesSelector,
  OutputAdminUavPlatform,
  OutputAdminUser,
  OutputAdminUsersOtgsSelector,
  OutputAdminUsersZonesSelector,
  OutputAdminZone,
  OutputAlternativeChannelsResponse,
  OutputAmmo,
  OutputAnalyticsChannelHeatmapItem,
  OutputAnalyticsMissionsDataItem,
  OutputAuthTokenResponse,
  OutputBookingData,
  OutputChannelDefinitionItem,
  OutputChannelsMap,
  OutputChatChannel,
  OutputChatChannelReadStatus,
  OutputChatMessage,
  OutputDeltaLogData,
  OutputDuplicateDivision,
  OutputEwFrequencySuggestions,
  OutputEwSuppressionSessionsList,
  OutputEwZonesResponse,
  OutputFaq,
  OutputFilePresign,
  OutputFiltersSelectItem,
  OutputFiltersSelectStringItem,
  OutputGeoJson,
  OutputGeoJsonFeature,
  OutputGeoPlace,
  OutputGeoReverse,
  OutputHistoryEditableData,
  OutputHistoryEvent,
  OutputHistoryEventEditableData,
  OutputLastFlightData,
  OutputMapZoneDataItem,
  OutputMissionData,
  OutputNews,
  OutputNotification,
  OutputOutputTeamVideoLink,
  OutputPilotTeamSettings,
  OutputPosition,
  OutputPositionStockStatistics,
  OutputReadStoreStats,
  OutputSession,
  OutputSessionData,
  OutputSessionsData,
  OutputSignalGroup,
  OutputSignalIntegrationLogItem,
  OutputSignalIntegrationStatus,
  OutputStockItem,
  OutputSystemPermission,
  OutputTargetData,
  OutputTargetSelectData,
  OutputTargetTypesResult,
  OutputTargetWithZoneSelectData,
  OutputTargetsResult,
  OutputTeamSessionInfo,
  OutputTeamShort,
  OutputTeamUsedChannels,
  OutputTotpSecretResponse,
  OutputTotpVerificationResponse,
  OutputTwoFactorStatusResponse,
  OutputUavCrewContext,
  OutputUavCrewMember,
  OutputUavCrewSettings,
  OutputUavMission,
  OutputUavMissionNote,
  OutputUavMissionStatusEvent,
  OutputUavMissionTemplate,
  OutputUavParsePreview,
  OutputUavPlatform,
  OutputUnrecognizedUavPlatform,
  OutputUserIdentity,
  OutputUserProfile,
  OutputUserShort,
  OutputVerificationChallengeResponse,
  OutputWalkthroughStatus,
  OutputWeatherStatus,
  OutputWebAuthnRegistrationBeginResponse,
  OutputWebAuthnRegistrationCompleteResponse,
  OutputWebAuthnVerificationBeginResponse,
  OutputWebAuthnVerificationCompleteResponse,
  OutputWindLabResult,
  OutputZone,
  OutputZoneAdminBroadcastMessage,
  OutputZoneAdminDivision,
  OutputZoneAdminRequest,
  OutputZoneChannelData,
  OutputZoneRequestsOtgsSelector,
  OutputZoneRequestsResult,
  OutputZoneRequestsZonesSelector,
  OutputZoneShort,
  RepositoriesWindMapPoint,
} from '../models/index';
import {
    HandlersWindVelocityRecordFromJSON,
    HandlersWindVelocityRecordToJSON,
    InputAdminAmmoFromJSON,
    InputAdminAmmoToJSON,
    InputAdminBrigadeFromJSON,
    InputAdminBrigadeToJSON,
    InputAdminChatChannelFromJSON,
    InputAdminChatChannelToJSON,
    InputAdminDivisionFromJSON,
    InputAdminDivisionToJSON,
    InputAdminElementCaptureRoomsFromJSON,
    InputAdminElementCaptureRoomsToJSON,
    InputAdminElementLoginFromJSON,
    InputAdminElementLoginToJSON,
    InputAdminOSGFromJSON,
    InputAdminOSGToJSON,
    InputAdminOTGFromJSON,
    InputAdminOTGToJSON,
    InputAdminOTGPolygonFromJSON,
    InputAdminOTGPolygonToJSON,
    InputAdminStockItemFromJSON,
    InputAdminStockItemToJSON,
    InputAdminStockMovementFromJSON,
    InputAdminStockMovementToJSON,
    InputAdminStockTransferFromJSON,
    InputAdminStockTransferToJSON,
    InputAdminTeamFromJSON,
    InputAdminTeamToJSON,
    InputAdminTeamMembersFromJSON,
    InputAdminTeamMembersToJSON,
    InputAdminUavPlatformFromJSON,
    InputAdminUavPlatformToJSON,
    InputAdminUavTeamActivationFromJSON,
    InputAdminUavTeamActivationToJSON,
    InputAdminUserFromJSON,
    InputAdminUserToJSON,
    InputAdminZoneFromJSON,
    InputAdminZoneToJSON,
    InputApproveTeamSessionFromJSON,
    InputApproveTeamSessionToJSON,
    InputAuthTokenFromJSON,
    InputAuthTokenToJSON,
    InputBeginWebAuthnRegistrationRequestFromJSON,
    InputBeginWebAuthnRegistrationRequestToJSON,
    InputBeginWebAuthnVerificationRequestFromJSON,
    InputBeginWebAuthnVerificationRequestToJSON,
    InputBroadcastRequestFromJSON,
    InputBroadcastRequestToJSON,
    InputBrowsersInfoFromJSON,
    InputBrowsersInfoToJSON,
    InputChannelMessageReadStatusFromJSON,
    InputChannelMessageReadStatusToJSON,
    InputChatMessageFromJSON,
    InputChatMessageToJSON,
    InputChatMessageReactionFromJSON,
    InputChatMessageReactionToJSON,
    InputCompleteWebAuthnRegistrationRequestFromJSON,
    InputCompleteWebAuthnRegistrationRequestToJSON,
    InputCompleteWebAuthnVerificationRequestFromJSON,
    InputCompleteWebAuthnVerificationRequestToJSON,
    InputCreateHistoryEventFromJSON,
    InputCreateHistoryEventToJSON,
    InputCreateTeamVideoLinkFromJSON,
    InputCreateTeamVideoLinkToJSON,
    InputDeleteWebAuthnCredentialRequestFromJSON,
    InputDeleteWebAuthnCredentialRequestToJSON,
    InputDisableTwoFactorRequestFromJSON,
    InputDisableTwoFactorRequestToJSON,
    InputEditAdminChatChannelFromJSON,
    InputEditAdminChatChannelToJSON,
    InputEditAdminUserFromJSON,
    InputEditAdminUserToJSON,
    InputEnableTwoFactorRequestFromJSON,
    InputEnableTwoFactorRequestToJSON,
    InputEwSuppressionSessionCreateFromJSON,
    InputEwSuppressionSessionCreateToJSON,
    InputFAQFromJSON,
    InputFAQToJSON,
    InputFilePresignFromJSON,
    InputFilePresignToJSON,
    InputGeoReverseFromJSON,
    InputGeoReverseToJSON,
    InputMergeDivisionsFromJSON,
    InputMergeDivisionsToJSON,
    InputMissionResultFromJSON,
    InputMissionResultToJSON,
    InputMissionVideoFromJSON,
    InputMissionVideoToJSON,
    InputNewsFromJSON,
    InputNewsToJSON,
    InputPositionFromJSON,
    InputPositionToJSON,
    InputPositionUpdateFromJSON,
    InputPositionUpdateToJSON,
    InputPushTokenFromJSON,
    InputPushTokenToJSON,
    InputRestartTeamSessionFromJSON,
    InputRestartTeamSessionToJSON,
    InputSaveMissionDropsFromJSON,
    InputSaveMissionDropsToJSON,
    InputSignalGroupRequestFromJSON,
    InputSignalGroupRequestToJSON,
    InputStartSessionFromJSON,
    InputStartSessionToJSON,
    InputSuspiciousUserEventFromJSON,
    InputSuspiciousUserEventToJSON,
    InputSystemPermissionFromJSON,
    InputSystemPermissionToJSON,
    InputTargetFromJSON,
    InputTargetToJSON,
    InputTargetImportFromJSON,
    InputTargetImportToJSON,
    InputUavCrewSettingsFromJSON,
    InputUavCrewSettingsToJSON,
    InputUavMissionFromJSON,
    InputUavMissionToJSON,
    InputUavMissionFlightParamsFromJSON,
    InputUavMissionFlightParamsToJSON,
    InputUavMissionFlightPathFromJSON,
    InputUavMissionFlightPathToJSON,
    InputUavMissionLoiterAreaFromJSON,
    InputUavMissionLoiterAreaToJSON,
    InputUavMissionNoteFromJSON,
    InputUavMissionNoteToJSON,
    InputUavMissionPositionOverrideFromJSON,
    InputUavMissionPositionOverrideToJSON,
    InputUavMissionShootdownFromJSON,
    InputUavMissionShootdownToJSON,
    InputUavMissionStatusFromJSON,
    InputUavMissionStatusToJSON,
    InputUavMissionTemplateFromJSON,
    InputUavMissionTemplateToJSON,
    InputUavParsePreviewFromJSON,
    InputUavParsePreviewToJSON,
    InputUpdateHistoryEventFromJSON,
    InputUpdateHistoryEventToJSON,
    InputUpdateMissionChannelsFromJSON,
    InputUpdateMissionChannelsToJSON,
    InputUpdatePilotTeamSettingsFromJSON,
    InputUpdatePilotTeamSettingsToJSON,
    InputUserProfileFromJSON,
    InputUserProfileToJSON,
    InputVerifyTotpCodeRequestFromJSON,
    InputVerifyTotpCodeRequestToJSON,
    InputVerifyTwoFactorRequestFromJSON,
    InputVerifyTwoFactorRequestToJSON,
    InputWindLabRequestFromJSON,
    InputWindLabRequestToJSON,
    InputZoneAdminZoneFromJSON,
    InputZoneAdminZoneToJSON,
    InputZoneRequestFromJSON,
    InputZoneRequestToJSON,
    OutputAdminAmmoFromJSON,
    OutputAdminAmmoToJSON,
    OutputAdminBrigadeFromJSON,
    OutputAdminBrigadeToJSON,
    OutputAdminChatChannelFromJSON,
    OutputAdminChatChannelToJSON,
    OutputAdminDetailedSessionFromJSON,
    OutputAdminDetailedSessionToJSON,
    OutputAdminDivisionFromJSON,
    OutputAdminDivisionToJSON,
    OutputAdminElementSessionFromJSON,
    OutputAdminElementSessionToJSON,
    OutputAdminOSGFromJSON,
    OutputAdminOSGToJSON,
    OutputAdminOTGFromJSON,
    OutputAdminOTGToJSON,
    OutputAdminPositionStockResponseFromJSON,
    OutputAdminPositionStockResponseToJSON,
    OutputAdminRoleSelectorFromJSON,
    OutputAdminRoleSelectorToJSON,
    OutputAdminSessionFromJSON,
    OutputAdminSessionToJSON,
    OutputAdminStockItemFromJSON,
    OutputAdminStockItemToJSON,
    OutputAdminTeamFromJSON,
    OutputAdminTeamToJSON,
    OutputAdminTeamsZonesSelectorFromJSON,
    OutputAdminTeamsZonesSelectorToJSON,
    OutputAdminUavPlatformFromJSON,
    OutputAdminUavPlatformToJSON,
    OutputAdminUserFromJSON,
    OutputAdminUserToJSON,
    OutputAdminUsersOtgsSelectorFromJSON,
    OutputAdminUsersOtgsSelectorToJSON,
    OutputAdminUsersZonesSelectorFromJSON,
    OutputAdminUsersZonesSelectorToJSON,
    OutputAdminZoneFromJSON,
    OutputAdminZoneToJSON,
    OutputAlternativeChannelsResponseFromJSON,
    OutputAlternativeChannelsResponseToJSON,
    OutputAmmoFromJSON,
    OutputAmmoToJSON,
    OutputAnalyticsChannelHeatmapItemFromJSON,
    OutputAnalyticsChannelHeatmapItemToJSON,
    OutputAnalyticsMissionsDataItemFromJSON,
    OutputAnalyticsMissionsDataItemToJSON,
    OutputAuthTokenResponseFromJSON,
    OutputAuthTokenResponseToJSON,
    OutputBookingDataFromJSON,
    OutputBookingDataToJSON,
    OutputChannelDefinitionItemFromJSON,
    OutputChannelDefinitionItemToJSON,
    OutputChannelsMapFromJSON,
    OutputChannelsMapToJSON,
    OutputChatChannelFromJSON,
    OutputChatChannelToJSON,
    OutputChatChannelReadStatusFromJSON,
    OutputChatChannelReadStatusToJSON,
    OutputChatMessageFromJSON,
    OutputChatMessageToJSON,
    OutputDeltaLogDataFromJSON,
    OutputDeltaLogDataToJSON,
    OutputDuplicateDivisionFromJSON,
    OutputDuplicateDivisionToJSON,
    OutputEwFrequencySuggestionsFromJSON,
    OutputEwFrequencySuggestionsToJSON,
    OutputEwSuppressionSessionsListFromJSON,
    OutputEwSuppressionSessionsListToJSON,
    OutputEwZonesResponseFromJSON,
    OutputEwZonesResponseToJSON,
    OutputFaqFromJSON,
    OutputFaqToJSON,
    OutputFilePresignFromJSON,
    OutputFilePresignToJSON,
    OutputFiltersSelectItemFromJSON,
    OutputFiltersSelectItemToJSON,
    OutputFiltersSelectStringItemFromJSON,
    OutputFiltersSelectStringItemToJSON,
    OutputGeoJsonFromJSON,
    OutputGeoJsonToJSON,
    OutputGeoJsonFeatureFromJSON,
    OutputGeoJsonFeatureToJSON,
    OutputGeoPlaceFromJSON,
    OutputGeoPlaceToJSON,
    OutputGeoReverseFromJSON,
    OutputGeoReverseToJSON,
    OutputHistoryEditableDataFromJSON,
    OutputHistoryEditableDataToJSON,
    OutputHistoryEventFromJSON,
    OutputHistoryEventToJSON,
    OutputHistoryEventEditableDataFromJSON,
    OutputHistoryEventEditableDataToJSON,
    OutputLastFlightDataFromJSON,
    OutputLastFlightDataToJSON,
    OutputMapZoneDataItemFromJSON,
    OutputMapZoneDataItemToJSON,
    OutputMissionDataFromJSON,
    OutputMissionDataToJSON,
    OutputNewsFromJSON,
    OutputNewsToJSON,
    OutputNotificationFromJSON,
    OutputNotificationToJSON,
    OutputOutputTeamVideoLinkFromJSON,
    OutputOutputTeamVideoLinkToJSON,
    OutputPilotTeamSettingsFromJSON,
    OutputPilotTeamSettingsToJSON,
    OutputPositionFromJSON,
    OutputPositionToJSON,
    OutputPositionStockStatisticsFromJSON,
    OutputPositionStockStatisticsToJSON,
    OutputReadStoreStatsFromJSON,
    OutputReadStoreStatsToJSON,
    OutputSessionFromJSON,
    OutputSessionToJSON,
    OutputSessionDataFromJSON,
    OutputSessionDataToJSON,
    OutputSessionsDataFromJSON,
    OutputSessionsDataToJSON,
    OutputSignalGroupFromJSON,
    OutputSignalGroupToJSON,
    OutputSignalIntegrationLogItemFromJSON,
    OutputSignalIntegrationLogItemToJSON,
    OutputSignalIntegrationStatusFromJSON,
    OutputSignalIntegrationStatusToJSON,
    OutputStockItemFromJSON,
    OutputStockItemToJSON,
    OutputSystemPermissionFromJSON,
    OutputSystemPermissionToJSON,
    OutputTargetDataFromJSON,
    OutputTargetDataToJSON,
    OutputTargetSelectDataFromJSON,
    OutputTargetSelectDataToJSON,
    OutputTargetTypesResultFromJSON,
    OutputTargetTypesResultToJSON,
    OutputTargetWithZoneSelectDataFromJSON,
    OutputTargetWithZoneSelectDataToJSON,
    OutputTargetsResultFromJSON,
    OutputTargetsResultToJSON,
    OutputTeamSessionInfoFromJSON,
    OutputTeamSessionInfoToJSON,
    OutputTeamShortFromJSON,
    OutputTeamShortToJSON,
    OutputTeamUsedChannelsFromJSON,
    OutputTeamUsedChannelsToJSON,
    OutputTotpSecretResponseFromJSON,
    OutputTotpSecretResponseToJSON,
    OutputTotpVerificationResponseFromJSON,
    OutputTotpVerificationResponseToJSON,
    OutputTwoFactorStatusResponseFromJSON,
    OutputTwoFactorStatusResponseToJSON,
    OutputUavCrewContextFromJSON,
    OutputUavCrewContextToJSON,
    OutputUavCrewMemberFromJSON,
    OutputUavCrewMemberToJSON,
    OutputUavCrewSettingsFromJSON,
    OutputUavCrewSettingsToJSON,
    OutputUavMissionFromJSON,
    OutputUavMissionToJSON,
    OutputUavMissionNoteFromJSON,
    OutputUavMissionNoteToJSON,
    OutputUavMissionStatusEventFromJSON,
    OutputUavMissionStatusEventToJSON,
    OutputUavMissionTemplateFromJSON,
    OutputUavMissionTemplateToJSON,
    OutputUavParsePreviewFromJSON,
    OutputUavParsePreviewToJSON,
    OutputUavPlatformFromJSON,
    OutputUavPlatformToJSON,
    OutputUnrecognizedUavPlatformFromJSON,
    OutputUnrecognizedUavPlatformToJSON,
    OutputUserIdentityFromJSON,
    OutputUserIdentityToJSON,
    OutputUserProfileFromJSON,
    OutputUserProfileToJSON,
    OutputUserShortFromJSON,
    OutputUserShortToJSON,
    OutputVerificationChallengeResponseFromJSON,
    OutputVerificationChallengeResponseToJSON,
    OutputWalkthroughStatusFromJSON,
    OutputWalkthroughStatusToJSON,
    OutputWeatherStatusFromJSON,
    OutputWeatherStatusToJSON,
    OutputWebAuthnRegistrationBeginResponseFromJSON,
    OutputWebAuthnRegistrationBeginResponseToJSON,
    OutputWebAuthnRegistrationCompleteResponseFromJSON,
    OutputWebAuthnRegistrationCompleteResponseToJSON,
    OutputWebAuthnVerificationBeginResponseFromJSON,
    OutputWebAuthnVerificationBeginResponseToJSON,
    OutputWebAuthnVerificationCompleteResponseFromJSON,
    OutputWebAuthnVerificationCompleteResponseToJSON,
    OutputWindLabResultFromJSON,
    OutputWindLabResultToJSON,
    OutputZoneFromJSON,
    OutputZoneToJSON,
    OutputZoneAdminBroadcastMessageFromJSON,
    OutputZoneAdminBroadcastMessageToJSON,
    OutputZoneAdminDivisionFromJSON,
    OutputZoneAdminDivisionToJSON,
    OutputZoneAdminRequestFromJSON,
    OutputZoneAdminRequestToJSON,
    OutputZoneChannelDataFromJSON,
    OutputZoneChannelDataToJSON,
    OutputZoneRequestsOtgsSelectorFromJSON,
    OutputZoneRequestsOtgsSelectorToJSON,
    OutputZoneRequestsResultFromJSON,
    OutputZoneRequestsResultToJSON,
    OutputZoneRequestsZonesSelectorFromJSON,
    OutputZoneRequestsZonesSelectorToJSON,
    OutputZoneShortFromJSON,
    OutputZoneShortToJSON,
    RepositoriesWindMapPointFromJSON,
    RepositoriesWindMapPointToJSON,
} from '../models/index';

export interface AddAdditionalMissionTimeRequest {
    id: number;
}

export interface AddChatMessageReactionRequest {
    messageId: number;
    request: InputChatMessageReaction;
}

export interface AddSignalIntegrationRequestRequest {
    request: InputSignalGroupRequest;
}

export interface AddUavMissionShootdownRequest {
    id: number;
    request: InputUavMissionShootdown;
}

export interface AdminDeleteChatChannelRequest {
    id: number;
}

export interface AdminElementLoginRequest {
    request: InputAdminElementLogin;
}

export interface AdminSetElementCaptureRoomsRequest {
    request: InputAdminElementCaptureRooms;
}

export interface ApproveTeamSessionRequest {
    id: number;
    request: InputApproveTeamSession;
}

export interface BeginWebAuthnRegistrationRequest {
    request?: InputBeginWebAuthnRegistrationRequest;
}

export interface BeginWebAuthnVerificationRequest {
    request: InputBeginWebAuthnVerificationRequest;
}

export interface BlockAdminDivisionRequest {
    id: number;
}

export interface BulkImportTargetsRequest {
    request: InputTargetImport;
}

export interface CancelEwSuppressionRequest {
    id: number;
}

export interface ChangeUavMissionStatusRequest {
    id: number;
    request: InputUavMissionStatus;
}

export interface ClearZoneQueueRequest {
    zone: number;
}

export interface CompleteWebAuthnRegistrationRequest {
    request: InputCompleteWebAuthnRegistrationRequest;
}

export interface CompleteWebAuthnVerificationRequest {
    request: InputCompleteWebAuthnVerificationRequest;
}

export interface ConfirmFileRequest {
    id: number;
}

export interface CreateAdminAmmoRequest {
    request: InputAdminAmmo;
}

export interface CreateAdminBrigadeRequest {
    request: InputAdminBrigade;
}

export interface CreateAdminChatChannelRequest {
    request: InputAdminChatChannel;
}

export interface CreateAdminDivisionRequest {
    request: InputAdminDivision;
}

export interface CreateAdminOSGRequest {
    request: InputAdminOSG;
}

export interface CreateAdminOTGRequest {
    request: InputAdminOTG;
}

export interface CreateAdminStockItemRequest {
    request: InputAdminStockItem;
}

export interface CreateAdminStockMovementRequest {
    id: number;
    request: InputAdminStockMovement;
}

export interface CreateAdminStockTransferRequest {
    id: number;
    request: InputAdminStockTransfer;
}

export interface CreateAdminTeamRequest {
    request: InputAdminTeam;
}

export interface CreateAdminTeamVideoLinkRequest {
    id: number;
    request: InputCreateTeamVideoLink;
}

export interface CreateAdminUavPlatformRequest {
    request: InputAdminUavPlatform;
}

export interface CreateAdminUserRequest {
    request: InputAdminUser;
}

export interface CreateAdminZoneRequest {
    request: InputAdminZone;
}

export interface CreateChatMessageRequest {
    request: InputChatMessage;
}

export interface CreateEwSuppressionRequest {
    request: InputEwSuppressionSessionCreate;
}

export interface CreateFAQRequest {
    request: InputFAQ;
}

export interface CreateHistoryEventRequest {
    request: InputCreateHistoryEvent;
}

export interface CreateNewsRequest {
    request: InputNews;
}

export interface CreatePilotTeamVideoLinkRequest {
    request: InputCreateTeamVideoLink;
}

export interface CreatePositionRequest {
    request: InputPosition;
}

export interface CreateSuspiciousUserEventRequest {
    request: InputSuspiciousUserEvent;
}

export interface CreateTargetHandlerRequest {
    request: InputTarget;
}

export interface CreateUavMissionRequest {
    request: InputUavMission;
}

export interface CreateUavMissionNoteRequest {
    id: number;
    request: InputUavMissionNote;
}

export interface CreateUavMissionTemplateRequest {
    request: InputUavMissionTemplate;
}

export interface CreateZoneRequestHandlerRequest {
    request: InputZoneRequest;
}

export interface DeleteAdminAmmoRequest {
    id: number;
}

export interface DeleteAdminBrigadeRequest {
    id: number;
}

export interface DeleteAdminDivisionRequest {
    id: number;
}

export interface DeleteAdminOSGRequest {
    id: number;
}

export interface DeleteAdminOTGRequest {
    id: number;
}

export interface DeleteAdminOTGPolygonRequest {
    id: number;
}

export interface DeleteAdminStockItemRequest {
    id: number;
}

export interface DeleteAdminStockItemWithRecountRequest {
    id: number;
}

export interface DeleteAdminTeamRequest {
    id: number;
}

export interface DeleteAdminTeamVideoLinkRequest {
    id: number;
    linkId: number;
}

export interface DeleteAdminUavPlatformRequest {
    id: number;
}

export interface DeleteAdminUserRequest {
    id: number;
}

export interface DeleteAdminZoneRequest {
    id: number;
}

export interface DeleteFAQRequest {
    id: number;
}

export interface DeleteHistoryEventRequest {
    id: number;
}

export interface DeleteLastUavMissionShootdownRequest {
    id: number;
}

export interface DeleteMissionRequest {
    id: number;
}

export interface DeleteNewsRequest {
    id: number;
}

export interface DeletePilotTeamVideoLinkRequest {
    id: number;
}

export interface DeletePositionRequest {
    id: number;
}

export interface DeleteSystemPermissionRequest {
    name: string;
}

export interface DeleteTargetRequest {
    id: number;
}

export interface DeleteUavMissionRequest {
    id: number;
}

export interface DeleteUavMissionEwReportRequest {
    id: number;
}

export interface DeleteUavMissionLoiterAreaRequest {
    id: number;
}

export interface DeleteUavMissionTemplateRequest {
    id: number;
}

export interface DeleteWebAuthnCredentialRequest {
    request: InputDeleteWebAuthnCredentialRequest;
}

export interface DisableTwoFactorRequest {
    request: InputDisableTwoFactorRequest;
}

export interface EditMissionResultRequest {
    id: number;
    request: InputMissionResult;
}

export interface EditMissionVideoRequest {
    id: number;
    request: InputMissionVideo;
}

export interface EditTargetHandlerRequest {
    id: number;
    request: InputTarget;
}

export interface EnableTwoFactorRequest {
    request: InputEnableTwoFactorRequest;
}

export interface ExitFromZoneRequest {
    zone: number;
}

export interface FinishSessionRequest {
    id: number;
}

export interface GeocodeReverseRequest {
    request: InputGeoReverse;
}

export interface GeocodeSearchRequest {
    q: string;
    lat?: number;
    lon?: number;
}

export interface GetAdminAmmoRequest {
    id: number;
}

export interface GetAdminBrigadeRequest {
    id: number;
}

export interface GetAdminBrigadesRequest {
    search?: string;
    sortBy?: string;
    orderBy?: GetAdminBrigadesOrderByEnum;
    limit?: number;
    offset?: number;
}

export interface GetAdminChatChannelRequest {
    id: number;
}

export interface GetAdminChatsRequest {
    search?: string;
    sortBy?: string;
    orderBy?: GetAdminChatsOrderByEnum;
    limit?: number;
    offset?: number;
}

export interface GetAdminDivisionRequest {
    id: number;
}

export interface GetAdminDivisionsRequest {
    search?: string;
    sortBy?: string;
    orderBy?: GetAdminDivisionsOrderByEnum;
    limit?: number;
    offset?: number;
}

export interface GetAdminGetDivisionFreePilotsRequest {
    id: number;
}

export interface GetAdminNewsRequest {
    search?: string;
    sortBy?: string;
    orderBy?: GetAdminNewsOrderByEnum;
    limit?: number;
    offset?: number;
}

export interface GetAdminOSGRequest {
    id: number;
}

export interface GetAdminOSGsRequest {
    search?: string;
    sortBy?: string;
    orderBy?: GetAdminOSGsOrderByEnum;
    limit?: number;
    offset?: number;
}

export interface GetAdminOTGRequest {
    id: number;
}

export interface GetAdminOTGPolygonRequest {
    id: number;
}

export interface GetAdminOTGsRequest {
    search?: string;
    sortBy?: string;
    orderBy?: GetAdminOTGsOrderByEnum;
    limit?: number;
    offset?: number;
}

export interface GetAdminPositionStockRequest {
    id: number;
    stockType?: string;
    stockItemId?: number;
    movementType?: string;
    limit?: number;
    offset?: number;
}

export interface GetAdminSessionInfoRequest {
    id: number;
}

export interface GetAdminSessionsRequest {
    search?: string;
    sortBy?: string;
    orderBy?: GetAdminSessionsOrderByEnum;
    limit?: number;
    offset?: number;
}

export interface GetAdminStockItemRequest {
    id: number;
}

export interface GetAdminStockItemsRequest {
    type?: string;
    search?: string;
    sortBy?: string;
    orderBy?: GetAdminStockItemsOrderByEnum;
    limit?: number;
    offset?: number;
}

export interface GetAdminTeamRequest {
    id: number;
}

export interface GetAdminTeamSessionRequest {
    id: number;
}

export interface GetAdminTeamVideoLinksRequest {
    id: number;
}

export interface GetAdminTeamsRequest {
    search?: string;
    sortBy?: string;
    orderBy?: GetAdminTeamsOrderByEnum;
    limit?: number;
    offset?: number;
}

export interface GetAdminUavCrewCandidatesRequest {
    id: number;
}

export interface GetAdminUavPlatformRequest {
    id: number;
}

export interface GetAdminUavPlatformsRequest {
    search?: string;
    sortBy?: string;
    orderBy?: GetAdminUavPlatformsOrderByEnum;
    limit?: number;
    offset?: number;
}

export interface GetAdminUavTeamMembersRequest {
    id: number;
}

export interface GetAdminUavTeamSettingsRequest {
    id: number;
}

export interface GetAdminUnrecognizedUavPlatformsRequest {
    limit?: number;
}

export interface GetAdminUserRequest {
    id: number;
}

export interface GetAdminUsersRequest {
    search?: string;
    sortBy?: string;
    orderBy?: GetAdminUsersOrderByEnum;
    limit?: number;
    offset?: number;
}

export interface GetAdminZoneRequest {
    id: number;
}

export interface GetAdminZonesRequest {
    search?: string;
    sortBy?: string;
    orderBy?: GetAdminZonesOrderByEnum;
    limit?: number;
    offset?: number;
}

export interface GetAlternativeChannelsRequest {
    id: number;
}

export interface GetAmmoListForFilterRequest {
    search?: string;
    limit?: number;
}

export interface GetAmmoListForMissionRequest {
    id: number;
}

export interface GetAnalyticsChannelHeatmapRequest {
    search: string;
}

export interface GetAnalyticsMissionsRequest {
    search: string;
    groupBy: string;
    chart?: number;
}

export interface GetAuthTokenRequest {
    request: InputAuthToken;
}

export interface GetBrigadesForFilterRequest {
    search?: string;
    limit?: number;
}

export interface GetChatMessagesRequest {
    channelId: number;
    beforeMessageId?: number;
    limit?: number;
}

export interface GetDirectionsForFilterRequest {
    search?: string;
    limit?: number;
}

export interface GetDivisionsForFilterRequest {
    search?: string;
    limit?: number;
}

export interface GetDroneListForFilterRequest {
    search?: string;
    limit?: number;
}

export interface GetFAQRequest {
    id: number;
}

export interface GetFlyHistoryRequest {
    search?: string;
    sortBy?: string;
    orderBy?: GetFlyHistoryOrderByEnum;
    limit?: number;
    offset?: number;
    _export?: number;
}

export interface GetFlyZoneChannelDataRequest {
    zone: number;
}

export interface GetHistoryEventDataDataRequest {
    id: number;
}

export interface GetHistoryEventsDeltaLogRequest {
    id: number;
}

export interface GetMissionDeltaLogRequest {
    id: number;
}

export interface GetMissionEditableDataRequest {
    id: number;
}

export interface GetMissionTagsForFilterRequest {
    search?: string;
    limit?: number;
}

export interface GetMissionTargetTypesForFilterRequest {
    search?: string;
    limit?: number;
}

export interface GetNewsItemRequest {
    id: number;
}

export interface GetOsgsForFilterRequest {
    search?: string;
    limit?: number;
}

export interface GetOtgsForFilterRequest {
    search?: string;
    limit?: number;
}

export interface GetPilotsForFilterRequest {
    search?: string;
    limit?: number;
}

export interface GetPositionRequest {
    id: number;
}

export interface GetPositionStockStatisticsRequest {
    id: number;
}

export interface GetPositionsRequest {
    search?: string;
    sortBy?: string;
    orderBy?: GetPositionsOrderByEnum;
    limit?: number;
    offset?: number;
    isHub?: string;
}

export interface GetSessionsDataRequest {
    division?: number;
}

export interface GetStockItemsRequest {
    type?: string;
}

export interface GetSystemPermissionsRequest {
    search?: string;
    sortBy?: string;
    orderBy?: GetSystemPermissionsOrderByEnum;
    limit?: number;
    offset?: number;
}

export interface GetTargetDataRequest {
    id: number;
}

export interface GetTargetListForMissionRequest {
    id: number;
}

export interface GetTargetsListRequest {
    search?: string;
    sortBy?: string;
    orderBy?: GetTargetsListOrderByEnum;
    limit?: number;
    offset?: number;
}

export interface GetTeamsForFilterRequest {
    search?: string;
    limit?: number;
}

export interface GetUavCrewsForFilterRequest {
    search?: string;
    limit?: number;
}

export interface GetUavMissionRequest {
    id: number;
}

export interface GetUavMissionNotesRequest {
    id: number;
}

export interface GetUavMissionStatusEventsRequest {
    id: number;
}

export interface GetUavMissionsRequest {
    mode?: GetUavMissionsModeEnum;
    search?: string;
    sortBy?: string;
    orderBy?: GetUavMissionsOrderByEnum;
    limit?: number;
    offset?: number;
}

export interface GetUavPlatformsForFilterRequest {
    search?: string;
    limit?: number;
}

export interface GetUavUnitsForFilterRequest {
    search?: string;
    limit?: number;
}

export interface GetWindMapRequest {
    altitude?: number;
    minLat?: number;
    minLng?: number;
    maxLat?: number;
    maxLng?: number;
}

export interface GetWindVelocityRequest {
    altitude?: number;
}

export interface GetZoneAdminBroadcastNotificationsListRequest {
    sortBy?: string;
    orderBy?: GetZoneAdminBroadcastNotificationsListOrderByEnum;
    limit?: number;
    offset?: number;
}

export interface GetZoneAdminOtgZonesListRequest {
    id: number;
}

export interface GetZoneAdminRequestRequest {
    id: number;
}

export interface GetZoneRequestsListRequest {
    sortBy?: string;
    orderBy?: GetZoneRequestsListOrderByEnum;
    limit?: number;
    offset?: number;
}

export interface GetZonesForFilterRequest {
    search?: string;
    limit?: number;
}

export interface ManageSystemPermissionRequest {
    name: string;
    request: InputSystemPermission;
}

export interface MarkNotificationReadRequest {
    id: number;
}

export interface MarkUavMissionNotesReadRequest {
    id: number;
}

export interface MergeDivisionsRequest {
    request: InputMergeDivisions;
}

export interface NotificationCheckPushTokenRequest {
    id: number;
}

export interface NotificationPushTokenRequest {
    request: InputPushToken;
}

export interface NotifyNewsRequest {
    id: number;
}

export interface PresignFileRequest {
    data: InputFilePresign;
}

export interface PreviewUavParseRequest {
    request: InputUavParsePreview;
}

export interface PutBrowserInfoRequest {
    request: InputBrowsersInfo;
}

export interface RefreshSingleReadStoreRequest {
    name: string;
}

export interface RemoveChatMessageReactionRequest {
    messageId: number;
    reactionId: number;
}

export interface ResetAdminUser2FARequest {
    id: number;
}

export interface RestartTeamSessionRequest {
    teamId: number;
    sessionId: number;
    request: InputRestartTeamSession;
}

export interface SaveMissionDropsRequest {
    id: number;
    request: InputSaveMissionDrops;
}

export interface ServeFileRequest {
    id: number;
}

export interface SetAdminUavTeamActivationRequest {
    id: number;
    request: InputAdminUavTeamActivation;
}

export interface SetAdminUavTeamMembersRequest {
    id: number;
    request: InputAdminTeamMembers;
}

export interface StartFlySessionRequest {
    request: InputStartSession;
}

export interface StopEwSuppressionRequest {
    id: number;
}

export interface UnblockAdminDivisionRequest {
    id: number;
}

export interface UnblockAdminUserRequest {
    id: number;
}

export interface UpdateAdminAmmoRequest {
    id: number;
    request: InputAdminAmmo;
}

export interface UpdateAdminBrigadeRequest {
    id: number;
    request: InputAdminBrigade;
}

export interface UpdateAdminChatChannelRequest {
    id: number;
    request: InputEditAdminChatChannel;
}

export interface UpdateAdminDivisionRequest {
    id: number;
    request: InputAdminDivision;
}

export interface UpdateAdminOSGRequest {
    id: number;
    request: InputAdminOSG;
}

export interface UpdateAdminOTGRequest {
    id: number;
    request: InputAdminOTG;
}

export interface UpdateAdminOTGPolygonRequest {
    id: number;
    request: InputAdminOTGPolygon;
}

export interface UpdateAdminStockItemRequest {
    id: number;
    request: InputAdminStockItem;
}

export interface UpdateAdminTeamRequest {
    id: number;
    request: InputAdminTeam;
}

export interface UpdateAdminUavPlatformRequest {
    id: number;
    request: InputAdminUavPlatform;
}

export interface UpdateAdminUavTeamSettingsRequest {
    id: number;
    request: InputUavCrewSettings;
}

export interface UpdateAdminUserRequest {
    id: number;
    request: InputEditAdminUser;
}

export interface UpdateAdminZoneRequest {
    id: number;
    request: InputAdminZone;
}

export interface UpdateChatReadStatusRequest {
    channelId: number;
    request: InputChannelMessageReadStatus;
}

export interface UpdateFAQRequest {
    id: number;
    request: InputFAQ;
}

export interface UpdateHistoryEventRequest {
    id: number;
    request: InputUpdateHistoryEvent;
}

export interface UpdateMissionChannelsRequest {
    id: number;
    request: InputUpdateMissionChannels;
}

export interface UpdateNewsRequest {
    id: number;
    request: InputNews;
}

export interface UpdatePilotTeamSettingsRequest {
    request: InputUpdatePilotTeamSettings;
}

export interface UpdatePositionRequest {
    id: number;
    request: InputPositionUpdate;
}

export interface UpdateUavCrewSettingsRequest {
    request: InputUavCrewSettings;
}

export interface UpdateUavMissionFlightParamsRequest {
    id: number;
    request: InputUavMissionFlightParams;
}

export interface UpdateUavMissionFlightPathRequest {
    id: number;
    request: InputUavMissionFlightPath;
}

export interface UpdateUavMissionLoiterAreaRequest {
    id: number;
    request: InputUavMissionLoiterArea;
}

export interface UpdateUavMissionPositionOverrideRequest {
    id: number;
    request: InputUavMissionPositionOverride;
}

export interface UpdateUserProfileRequest {
    request: InputUserProfile;
}

export interface VerifyTotpCodeRequest {
    request: InputVerifyTotpCodeRequest;
}

export interface VerifyTwoFactorRequest {
    request: InputVerifyTwoFactorRequest;
}

export interface WindLabRequest {
    request: InputWindLabRequest;
}

export interface ZoneAdminApproveRequestRequest {
    id: number;
    request: InputZoneAdminZone;
}

export interface ZoneAdminBroadcastCreateNotificationRequest {
    request: InputBroadcastRequest;
}

export interface ZoneAdminDeclineRequestRequest {
    id: number;
}

export interface ZoneAdminDeleteDivisionFromZoneRequest {
    divisionId: number;
    zoneId: number;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Додатковий час для польотної місії
     */
    async addAdditionalMissionTimeRaw(requestParameters: AddAdditionalMissionTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling addAdditionalMissionTime().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/missions/{id}/additional-time`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Додатковий час для польотної місії
     */
    async addAdditionalMissionTime(requestParameters: AddAdditionalMissionTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.addAdditionalMissionTimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Додати реакцію в чаті
     */
    async addChatMessageReactionRaw(requestParameters: AddChatMessageReactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['messageId'] == null) {
            throw new runtime.RequiredError(
                'messageId',
                'Required parameter "messageId" was null or undefined when calling addChatMessageReaction().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling addChatMessageReaction().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/chat/message/{message_id}/reactions`.replace(`{${"message_id"}}`, encodeURIComponent(String(requestParameters['messageId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputChatMessageReactionToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Додати реакцію в чаті
     */
    async addChatMessageReaction(requestParameters: AddChatMessageReactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.addChatMessageReactionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Запит на інтеграцію з signal
     * Запит на інтеграцію з signal
     */
    async addSignalIntegrationRequestRaw(requestParameters: AddSignalIntegrationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling addSignalIntegrationRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/signal`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputSignalGroupRequestToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Запит на інтеграцію з signal
     * Запит на інтеграцію з signal
     */
    async addSignalIntegrationRequest(requestParameters: AddSignalIntegrationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addSignalIntegrationRequestRaw(requestParameters, initOverrides);
    }

    /**
     * Додає точку збиття (MGRS, час фіксує сервер) з наступним порядковим номером — екіпаж міг продовжити на резервному борті ту саму заявку. Атомарно переводить заявку у статус awaiting_launch (очікування повторного вильоту)
     * Новий запис у журналі збитих бортів заявки
     */
    async addUavMissionShootdownRaw(requestParameters: AddUavMissionShootdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling addUavMissionShootdown().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling addUavMissionShootdown().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/uav-missions/{id}/shootdowns`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputUavMissionShootdownToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Додає точку збиття (MGRS, час фіксує сервер) з наступним порядковим номером — екіпаж міг продовжити на резервному борті ту саму заявку. Атомарно переводить заявку у статус awaiting_launch (очікування повторного вильоту)
     * Новий запис у журналі збитих бортів заявки
     */
    async addUavMissionShootdown(requestParameters: AddUavMissionShootdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.addUavMissionShootdownRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Видалення чату
     */
    async adminDeleteChatChannelRaw(requestParameters: AdminDeleteChatChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminDeleteChatChannel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/chat_channel/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Видалення чату
     */
    async adminDeleteChatChannel(requestParameters: AdminDeleteChatChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminDeleteChatChannelRaw(requestParameters, initOverrides);
    }

    /**
     * Зупиняє sync, видаляє збережену сесію бота й спорожнює crypto-store (E2EE-ключі). Після цього потрібна повторна авторизація через SSO.
     * Забути сесію Element-бота
     */
    async adminElementForgetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputAdminElementSession>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/element/session/forget`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputAdminElementSessionFromJSON(jsonValue));
    }

    /**
     * Зупиняє sync, видаляє збережену сесію бота й спорожнює crypto-store (E2EE-ключі). Після цього потрібна повторна авторизація через SSO.
     * Забути сесію Element-бота
     */
    async adminElementForget(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputAdminElementSession> {
        const response = await this.adminElementForgetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Ставить авторизацію Element/Matrix-бота (одноразовий SSO login token + recovery key) у чергу бот-процесу й одразу повертає поточний стан сесії. Результат (success/error) прилітає ініціатору подією element_bot_auth у Centrifugo (personal:user#id). Секрети не зберігаються.
     * Авторизація Element-бота (асинхронна)
     */
    async adminElementLoginRaw(requestParameters: AdminElementLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputAdminElementSession>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling adminElementLogin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/element/session/login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminElementLoginToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputAdminElementSessionFromJSON(jsonValue));
    }

    /**
     * Ставить авторизацію Element/Matrix-бота (одноразовий SSO login token + recovery key) у чергу бот-процесу й одразу повертає поточний стан сесії. Результат (success/error) прилітає ініціатору подією element_bot_auth у Centrifugo (personal:user#id). Секрети не зберігаються.
     * Авторизація Element-бота (асинхронна)
     */
    async adminElementLogin(requestParameters: AdminElementLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputAdminElementSession> {
        const response = await this.adminElementLoginRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Сигналить supervisor\'у перепідключити бота: зупиняє й піднімає sync заново з збереженого токена (без re-auth, без втрати crypto). Для розчистки завислого стану.
     * Перезапустити Element-бота (soft)
     */
    async adminElementReconnectRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputAdminElementSession>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/element/reconnect`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputAdminElementSessionFromJSON(jsonValue));
    }

    /**
     * Сигналить supervisor\'у перепідключити бота: зупиняє й піднімає sync заново з збереженого токена (без re-auth, без втрати crypto). Для розчистки завислого стану.
     * Перезапустити Element-бота (soft)
     */
    async adminElementReconnect(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputAdminElementSession> {
        const response = await this.adminElementReconnectRaw(initOverrides);
        return await response.value();
    }

    /**
     * Задає перелік кімнат (room id), у яких бот обробляє повідомлення. Порожній список - бот не обробляє жодної кімнати, доки не додано хоча б одну. Зміна тригерить реконект бота. brigadeId кімнати визначає бригаду нових заявок з неї (скоуп доступу бригадних ролей).
     * Оновити allow-list кімнат Element-бота
     */
    async adminSetElementCaptureRoomsRaw(requestParameters: AdminSetElementCaptureRoomsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputAdminElementSession>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling adminSetElementCaptureRooms().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/element/capture-rooms`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminElementCaptureRoomsToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputAdminElementSessionFromJSON(jsonValue));
    }

    /**
     * Задає перелік кімнат (room id), у яких бот обробляє повідомлення. Порожній список - бот не обробляє жодної кімнати, доки не додано хоча б одну. Зміна тригерить реконект бота. brigadeId кімнати визначає бригаду нових заявок з неї (скоуп доступу бригадних ролей).
     * Оновити allow-list кімнат Element-бота
     */
    async adminSetElementCaptureRooms(requestParameters: AdminSetElementCaptureRoomsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputAdminElementSession> {
        const response = await this.adminSetElementCaptureRoomsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Затвердження сесії екіпажу, у разі відсутності такої сесії в БД буде створена нова сесія
     * Затвердження сесії
     */
    async approveTeamSessionRaw(requestParameters: ApproveTeamSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling approveTeamSession().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling approveTeamSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/sessions/team/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputApproveTeamSessionToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Затвердження сесії екіпажу, у разі відсутності такої сесії в БД буде створена нова сесія
     * Затвердження сесії
     */
    async approveTeamSession(requestParameters: ApproveTeamSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.approveTeamSessionRaw(requestParameters, initOverrides);
    }

    /**
     * Генерує challenge для реєстрації нового WebAuthn пристрою
     * Початок реєстрації WebAuthn credential
     */
    async beginWebAuthnRegistrationRaw(requestParameters: BeginWebAuthnRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputWebAuthnRegistrationBeginResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/two-factor/webauthn/register/begin`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputBeginWebAuthnRegistrationRequestToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputWebAuthnRegistrationBeginResponseFromJSON(jsonValue));
    }

    /**
     * Генерує challenge для реєстрації нового WebAuthn пристрою
     * Початок реєстрації WebAuthn credential
     */
    async beginWebAuthnRegistration(requestParameters: BeginWebAuthnRegistrationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputWebAuthnRegistrationBeginResponse> {
        const response = await this.beginWebAuthnRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Генерує challenge для верифікації через WebAuthn
     * Початок верифікації WebAuthn
     */
    async beginWebAuthnVerificationRaw(requestParameters: BeginWebAuthnVerificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputWebAuthnVerificationBeginResponse>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling beginWebAuthnVerification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/two-factor/webauthn/verify/begin`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputBeginWebAuthnVerificationRequestToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputWebAuthnVerificationBeginResponseFromJSON(jsonValue));
    }

    /**
     * Генерує challenge для верифікації через WebAuthn
     * Початок верифікації WebAuthn
     */
    async beginWebAuthnVerification(requestParameters: BeginWebAuthnVerificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputWebAuthnVerificationBeginResponse> {
        const response = await this.beginWebAuthnVerificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Блокування підрозділу в адміністративному інтерфейсі. При блокуванні завершуються всі активні бойові чергування підрозділу
     * Блокування підрозділу
     */
    async blockAdminDivisionRaw(requestParameters: BlockAdminDivisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling blockAdminDivision().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/division/{id}/block`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Блокування підрозділу в адміністративному інтерфейсі. При блокуванні завершуються всі активні бойові чергування підрозділу
     * Блокування підрозділу
     */
    async blockAdminDivision(requestParameters: BlockAdminDivisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.blockAdminDivisionRaw(requestParameters, initOverrides);
    }

    /**
     * Масовий імпорт цілей для зони
     */
    async bulkImportTargetsRaw(requestParameters: BulkImportTargetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling bulkImportTargets().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/targets/bulk-import`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputTargetImportToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Масовий імпорт цілей для зони
     */
    async bulkImportTargets(requestParameters: BulkImportTargetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.bulkImportTargetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Скасування запланованої або активної сесії подавлення
     * Скасування сесії подавлення
     */
    async cancelEwSuppressionRaw(requestParameters: CancelEwSuppressionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cancelEwSuppression().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/ew/suppressions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Скасування запланованої або активної сесії подавлення
     * Скасування сесії подавлення
     */
    async cancelEwSuppression(requestParameters: CancelEwSuppressionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelEwSuppressionRaw(requestParameters, initOverrides);
    }

    /**
     * Переводить місію у нову фазу польотної операції та пише запис у журнал статусів
     * Зміна статусу uav-місії
     */
    async changeUavMissionStatusRaw(requestParameters: ChangeUavMissionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling changeUavMissionStatus().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling changeUavMissionStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/uav-missions/{id}/status`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: InputUavMissionStatusToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Переводить місію у нову фазу польотної операції та пише запис у журнал статусів
     * Зміна статусу uav-місії
     */
    async changeUavMissionStatus(requestParameters: ChangeUavMissionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.changeUavMissionStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Очищення черги польотів в рамках зони
     * Очищення черги польотів
     */
    async clearZoneQueueRaw(requestParameters: ClearZoneQueueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['zone'] == null) {
            throw new runtime.RequiredError(
                'zone',
                'Required parameter "zone" was null or undefined when calling clearZoneQueue().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/fly/queue/{zone}`.replace(`{${"zone"}}`, encodeURIComponent(String(requestParameters['zone']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Очищення черги польотів в рамках зони
     * Очищення черги польотів
     */
    async clearZoneQueue(requestParameters: ClearZoneQueueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.clearZoneQueueRaw(requestParameters, initOverrides);
    }

    /**
     * Завершує реєстрацію нового WebAuthn пристрою
     * Завершення реєстрації WebAuthn credential
     */
    async completeWebAuthnRegistrationRaw(requestParameters: CompleteWebAuthnRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputWebAuthnRegistrationCompleteResponse>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling completeWebAuthnRegistration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/two-factor/webauthn/register/complete`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputCompleteWebAuthnRegistrationRequestToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputWebAuthnRegistrationCompleteResponseFromJSON(jsonValue));
    }

    /**
     * Завершує реєстрацію нового WebAuthn пристрою
     * Завершення реєстрації WebAuthn credential
     */
    async completeWebAuthnRegistration(requestParameters: CompleteWebAuthnRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputWebAuthnRegistrationCompleteResponse> {
        const response = await this.completeWebAuthnRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Завершує верифікацію через WebAuthn
     * Завершення верифікації WebAuthn
     */
    async completeWebAuthnVerificationRaw(requestParameters: CompleteWebAuthnVerificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputWebAuthnVerificationCompleteResponse>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling completeWebAuthnVerification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/two-factor/webauthn/verify/complete`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputCompleteWebAuthnVerificationRequestToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputWebAuthnVerificationCompleteResponseFromJSON(jsonValue));
    }

    /**
     * Завершує верифікацію через WebAuthn
     * Завершення верифікації WebAuthn
     */
    async completeWebAuthnVerification(requestParameters: CompleteWebAuthnVerificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputWebAuthnVerificationCompleteResponse> {
        const response = await this.completeWebAuthnVerificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Підтвердити збережений файл в S3
     */
    async confirmFileRaw(requestParameters: ConfirmFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling confirmFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/files/confirm/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Підтвердити збережений файл в S3
     */
    async confirmFile(requestParameters: ConfirmFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.confirmFileRaw(requestParameters, initOverrides);
    }

    /**
     * Відкриття потоку для системи сповіщень від серверу за допомогою SSE (Server-sent events)
     * Канал сповіщень
     */
    async connectApiStreamRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/stream`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Відкриття потоку для системи сповіщень від серверу за допомогою SSE (Server-sent events)
     * Канал сповіщень
     */
    async connectApiStream(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.connectApiStreamRaw(initOverrides);
    }

    /**
     * Створення нового БК в адміністративному інтерфейсі
     * Створення БК
     */
    async createAdminAmmoRaw(requestParameters: CreateAdminAmmoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createAdminAmmo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/ammo`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminAmmoToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Створення нового БК в адміністративному інтерфейсі
     * Створення БК
     */
    async createAdminAmmo(requestParameters: CreateAdminAmmoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.createAdminAmmoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Створення нової бригади в адміністративному інтерфейсі
     * Створення бригади
     */
    async createAdminBrigadeRaw(requestParameters: CreateAdminBrigadeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createAdminBrigade().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/brigade`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminBrigadeToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Створення нової бригади в адміністративному інтерфейсі
     * Створення бригади
     */
    async createAdminBrigade(requestParameters: CreateAdminBrigadeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.createAdminBrigadeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Створення чату
     */
    async createAdminChatChannelRaw(requestParameters: CreateAdminChatChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createAdminChatChannel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/chat_channel`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminChatChannelToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Створення чату
     */
    async createAdminChatChannel(requestParameters: CreateAdminChatChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.createAdminChatChannelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Створення нового підрозділу в адміністративному інтерфейсі
     * Створення підрозділу
     */
    async createAdminDivisionRaw(requestParameters: CreateAdminDivisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createAdminDivision().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/division`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminDivisionToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Створення нового підрозділу в адміністративному інтерфейсі
     * Створення підрозділу
     */
    async createAdminDivision(requestParameters: CreateAdminDivisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.createAdminDivisionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Створення нової ОСУВ в адміністративному інтерфейсі
     * Створення ОСУВ
     */
    async createAdminOSGRaw(requestParameters: CreateAdminOSGRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createAdminOSG().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/osg`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminOSGToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Створення нової ОСУВ в адміністративному інтерфейсі
     * Створення ОСУВ
     */
    async createAdminOSG(requestParameters: CreateAdminOSGRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.createAdminOSGRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Створення нового корпусу в адміністративному інтерфейсі
     * Створення корпусу
     */
    async createAdminOTGRaw(requestParameters: CreateAdminOTGRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createAdminOTG().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/otg`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminOTGToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Створення нового корпусу в адміністративному інтерфейсі
     * Створення корпусу
     */
    async createAdminOTG(requestParameters: CreateAdminOTGRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.createAdminOTGRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Створення нового засобу (дрона/боєкомплекту) в адміністративному інтерфейсі
     * Створення засобу
     */
    async createAdminStockItemRaw(requestParameters: CreateAdminStockItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createAdminStockItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/stock-items`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminStockItemToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Створення нового засобу (дрона/боєкомплекту) в адміністративному інтерфейсі
     * Створення засобу
     */
    async createAdminStockItem(requestParameters: CreateAdminStockItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.createAdminStockItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Додавання, списання або переоблік засобів на позиції
     * Створення руху засобів
     */
    async createAdminStockMovementRaw(requestParameters: CreateAdminStockMovementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createAdminStockMovement().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createAdminStockMovement().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/positions/{id}/stock/movement`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminStockMovementToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Додавання, списання або переоблік засобів на позиції
     * Створення руху засобів
     */
    async createAdminStockMovement(requestParameters: CreateAdminStockMovementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.createAdminStockMovementRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Переміщення засобів з однієї позиції/хабу до іншої. Виконується в одній транзакції: subtract на джерелі, add на призначенні.
     * Переміщення засобів між позиціями/хабами
     */
    async createAdminStockTransferRaw(requestParameters: CreateAdminStockTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createAdminStockTransfer().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createAdminStockTransfer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/positions/{id}/stock/transfer`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminStockTransferToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Переміщення засобів з однієї позиції/хабу до іншої. Виконується в одній транзакції: subtract на джерелі, add на призначенні.
     * Переміщення засобів між позиціями/хабами
     */
    async createAdminStockTransfer(requestParameters: CreateAdminStockTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createAdminStockTransferRaw(requestParameters, initOverrides);
    }

    /**
     * Створення нового екіпажу в адміністративному інтерфейсі
     * Створення екіпажу
     */
    async createAdminTeamRaw(requestParameters: CreateAdminTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createAdminTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/team`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminTeamToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Створення нового екіпажу в адміністративному інтерфейсі
     * Створення екіпажу
     */
    async createAdminTeam(requestParameters: CreateAdminTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.createAdminTeamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Додавання відео-посилання екіпажу (адмін)
     */
    async createAdminTeamVideoLinkRaw(requestParameters: CreateAdminTeamVideoLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputOutputTeamVideoLink>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createAdminTeamVideoLink().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createAdminTeamVideoLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/teams/{id}/video-links`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputCreateTeamVideoLinkToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputOutputTeamVideoLinkFromJSON(jsonValue));
    }

    /**
     * Додавання відео-посилання екіпажу (адмін)
     */
    async createAdminTeamVideoLink(requestParameters: CreateAdminTeamVideoLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputOutputTeamVideoLink> {
        const response = await this.createAdminTeamVideoLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Створення нового БпЛА в адміністративному інтерфейсі
     * Створення БпЛА
     */
    async createAdminUavPlatformRaw(requestParameters: CreateAdminUavPlatformRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createAdminUavPlatform().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/uav-platforms`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminUavPlatformToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Створення нового БпЛА в адміністративному інтерфейсі
     * Створення БпЛА
     */
    async createAdminUavPlatform(requestParameters: CreateAdminUavPlatformRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.createAdminUavPlatformRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Створення нового користувача в адміністративному інтерфейсі
     * Створення користувача
     */
    async createAdminUserRaw(requestParameters: CreateAdminUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createAdminUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/user`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminUserToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Створення нового користувача в адміністративному інтерфейсі
     * Створення користувача
     */
    async createAdminUser(requestParameters: CreateAdminUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.createAdminUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Створення нової зони в адміністративному інтерфейсі
     * Створення зони
     */
    async createAdminZoneRaw(requestParameters: CreateAdminZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createAdminZone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/zone`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminZoneToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Створення нової зони в адміністративному інтерфейсі
     * Створення зони
     */
    async createAdminZone(requestParameters: CreateAdminZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.createAdminZoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Створення повідомлення
     */
    async createChatMessageRaw(requestParameters: CreateChatMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createChatMessage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/chat/message`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputChatMessageToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Створення повідомлення
     */
    async createChatMessage(requestParameters: CreateChatMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.createChatMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Створення нової сесії подавлення частот
     * Створення сесії подавлення
     */
    async createEwSuppressionRaw(requestParameters: CreateEwSuppressionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createEwSuppression().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/ew/suppressions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputEwSuppressionSessionCreateToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Створення нової сесії подавлення частот
     * Створення сесії подавлення
     */
    async createEwSuppression(requestParameters: CreateEwSuppressionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.createEwSuppressionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Створення FAQ запису
     */
    async createFAQRaw(requestParameters: CreateFAQRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createFAQ().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/faq`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputFAQToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Створення FAQ запису
     */
    async createFAQ(requestParameters: CreateFAQRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.createFAQRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Створення нової історичної події
     */
    async createHistoryEventRaw(requestParameters: CreateHistoryEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createHistoryEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/history-events`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputCreateHistoryEventToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Створення нової історичної події
     */
    async createHistoryEvent(requestParameters: CreateHistoryEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.createHistoryEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Створення новини
     */
    async createNewsRaw(requestParameters: CreateNewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createNews().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/news`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputNewsToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Створення новини
     */
    async createNews(requestParameters: CreateNewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.createNewsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Додавання відео-посилання для екіпажу пілота
     */
    async createPilotTeamVideoLinkRaw(requestParameters: CreatePilotTeamVideoLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputOutputTeamVideoLink>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createPilotTeamVideoLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/pilot/team-video-links`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputCreateTeamVideoLinkToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputOutputTeamVideoLinkFromJSON(jsonValue));
    }

    /**
     * Додавання відео-посилання для екіпажу пілота
     */
    async createPilotTeamVideoLink(requestParameters: CreatePilotTeamVideoLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputOutputTeamVideoLink> {
        const response = await this.createPilotTeamVideoLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Створення нової позиції з валідацією доступу до підрозділу через ACL. Для командирів (IstarDivision) divisionId підставляється автоматично.
     * Створення позиції
     */
    async createPositionRaw(requestParameters: CreatePositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createPosition().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/positions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputPositionToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Створення нової позиції з валідацією доступу до підрозділу через ACL. Для командирів (IstarDivision) divisionId підставляється автоматично.
     * Створення позиції
     */
    async createPosition(requestParameters: CreatePositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.createPositionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Збереження підозрілої активності користувача
     */
    async createSuspiciousUserEventRaw(requestParameters: CreateSuspiciousUserEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createSuspiciousUserEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/analytics/se`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputSuspiciousUserEventToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Збереження підозрілої активності користувача
     */
    async createSuspiciousUserEvent(requestParameters: CreateSuspiciousUserEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createSuspiciousUserEventRaw(requestParameters, initOverrides);
    }

    /**
     * Створення цілі
     */
    async createTargetHandlerRaw(requestParameters: CreateTargetHandlerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createTargetHandler().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/targets`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputTargetToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Створення цілі
     */
    async createTargetHandler(requestParameters: CreateTargetHandlerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.createTargetHandlerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Створює заявку з форми диспетчерської (без Element). Маршрут приходить разом із заявкою (3-10 точок), район розвідки обов\'язковий для розвідників. Заявка прив\'язується до підрозділу автора.
     * Подача заявки на політ борта
     */
    async createUavMissionRaw(requestParameters: CreateUavMissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputUavMission>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createUavMission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/uav-missions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputUavMissionToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputUavMissionFromJSON(jsonValue));
    }

    /**
     * Створює заявку з форми диспетчерської (без Element). Маршрут приходить разом із заявкою (3-10 точок), район розвідки обов\'язковий для розвідників. Заявка прив\'язується до підрозділу автора.
     * Подача заявки на політ борта
     */
    async createUavMission(requestParameters: CreateUavMissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputUavMission> {
        const response = await this.createUavMissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Додає нотатку чергового у тред заявки на політ борта
     * Додати нотатку чергового
     */
    async createUavMissionNoteRaw(requestParameters: CreateUavMissionNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createUavMissionNote().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createUavMissionNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/uav-missions/{id}/notes`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputUavMissionNoteToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Додає нотатку чергового у тред заявки на політ борта
     * Додати нотатку чергового
     */
    async createUavMissionNote(requestParameters: CreateUavMissionNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.createUavMissionNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Зберігає знімок форми заявки (без дати й часу вильоту) для повторного використання
     * Збереження шаблону заявки
     */
    async createUavMissionTemplateRaw(requestParameters: CreateUavMissionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputUavMissionTemplate>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createUavMissionTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/uav-mission-templates`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputUavMissionTemplateToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputUavMissionTemplateFromJSON(jsonValue));
    }

    /**
     * Зберігає знімок форми заявки (без дати й часу вильоту) для повторного використання
     * Збереження шаблону заявки
     */
    async createUavMissionTemplate(requestParameters: CreateUavMissionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputUavMissionTemplate> {
        const response = await this.createUavMissionTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Створення запиту на приєднання до зони
     */
    async createZoneRequestHandlerRaw(requestParameters: CreateZoneRequestHandlerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling createZoneRequestHandler().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/division/zone-requests`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputZoneRequestToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Створення запиту на приєднання до зони
     */
    async createZoneRequestHandler(requestParameters: CreateZoneRequestHandlerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.createZoneRequestHandlerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Видалення БК в адміністративному інтерфейсі
     * Видалення БК
     */
    async deleteAdminAmmoRaw(requestParameters: DeleteAdminAmmoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteAdminAmmo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/ammo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Видалення БК в адміністративному інтерфейсі
     * Видалення БК
     */
    async deleteAdminAmmo(requestParameters: DeleteAdminAmmoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAdminAmmoRaw(requestParameters, initOverrides);
    }

    /**
     * Видалення бригади в адміністративному інтерфейсі
     * Видалення бригади
     */
    async deleteAdminBrigadeRaw(requestParameters: DeleteAdminBrigadeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteAdminBrigade().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/brigade/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Видалення бригади в адміністративному інтерфейсі
     * Видалення бригади
     */
    async deleteAdminBrigade(requestParameters: DeleteAdminBrigadeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAdminBrigadeRaw(requestParameters, initOverrides);
    }

    /**
     * Видалення підрозділу в адміністративному інтерфейсі
     * Видалення підрозділу
     */
    async deleteAdminDivisionRaw(requestParameters: DeleteAdminDivisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteAdminDivision().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/division/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Видалення підрозділу в адміністративному інтерфейсі
     * Видалення підрозділу
     */
    async deleteAdminDivision(requestParameters: DeleteAdminDivisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAdminDivisionRaw(requestParameters, initOverrides);
    }

    /**
     * Видалення ОСУВ в адміністративному інтерфейсі
     * Видалення ОСУВ
     */
    async deleteAdminOSGRaw(requestParameters: DeleteAdminOSGRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteAdminOSG().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/osg/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Видалення ОСУВ в адміністративному інтерфейсі
     * Видалення ОСУВ
     */
    async deleteAdminOSG(requestParameters: DeleteAdminOSGRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAdminOSGRaw(requestParameters, initOverrides);
    }

    /**
     * Видалення корпусу в адміністративному інтерфейсі
     * Видалення корпусу
     */
    async deleteAdminOTGRaw(requestParameters: DeleteAdminOTGRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteAdminOTG().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/otg/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Видалення корпусу в адміністративному інтерфейсі
     * Видалення корпусу
     */
    async deleteAdminOTG(requestParameters: DeleteAdminOTGRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAdminOTGRaw(requestParameters, initOverrides);
    }

    /**
     * Очищення меж корпусу. Сам корпус лишається
     * Видалення полігона корпусу
     */
    async deleteAdminOTGPolygonRaw(requestParameters: DeleteAdminOTGPolygonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteAdminOTGPolygon().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/otg/{id}/polygon`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Очищення меж корпусу. Сам корпус лишається
     * Видалення полігона корпусу
     */
    async deleteAdminOTGPolygon(requestParameters: DeleteAdminOTGPolygonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAdminOTGPolygonRaw(requestParameters, initOverrides);
    }

    /**
     * Видалення засобу в адміністративному інтерфейсі
     * Видалення засобу
     */
    async deleteAdminStockItemRaw(requestParameters: DeleteAdminStockItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteAdminStockItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/stock-items/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Видалення засобу в адміністративному інтерфейсі
     * Видалення засобу
     */
    async deleteAdminStockItem(requestParameters: DeleteAdminStockItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAdminStockItemRaw(requestParameters, initOverrides);
    }

    /**
     * Видалення засобу з автоматичним встановленням кількості 0 на всіх позиціях
     * Видалення засобу з переобліком
     */
    async deleteAdminStockItemWithRecountRaw(requestParameters: DeleteAdminStockItemWithRecountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteAdminStockItemWithRecount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/stock-items/{id}/delete-with-recount`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Видалення засобу з автоматичним встановленням кількості 0 на всіх позиціях
     * Видалення засобу з переобліком
     */
    async deleteAdminStockItemWithRecount(requestParameters: DeleteAdminStockItemWithRecountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAdminStockItemWithRecountRaw(requestParameters, initOverrides);
    }

    /**
     * Видалення екіпажу в адміністративному інтерфейсі
     * Видалення екіпажу
     */
    async deleteAdminTeamRaw(requestParameters: DeleteAdminTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteAdminTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/team/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Видалення екіпажу в адміністративному інтерфейсі
     * Видалення екіпажу
     */
    async deleteAdminTeam(requestParameters: DeleteAdminTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAdminTeamRaw(requestParameters, initOverrides);
    }

    /**
     * Видалення відео-посилання екіпажу (адмін)
     */
    async deleteAdminTeamVideoLinkRaw(requestParameters: DeleteAdminTeamVideoLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteAdminTeamVideoLink().'
            );
        }

        if (requestParameters['linkId'] == null) {
            throw new runtime.RequiredError(
                'linkId',
                'Required parameter "linkId" was null or undefined when calling deleteAdminTeamVideoLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/teams/{id}/video-links/{linkId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"linkId"}}`, encodeURIComponent(String(requestParameters['linkId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Видалення відео-посилання екіпажу (адмін)
     */
    async deleteAdminTeamVideoLink(requestParameters: DeleteAdminTeamVideoLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAdminTeamVideoLinkRaw(requestParameters, initOverrides);
    }

    /**
     * Видалення БпЛА в адміністративному інтерфейсі (м\'яке)
     * Видалення БпЛА
     */
    async deleteAdminUavPlatformRaw(requestParameters: DeleteAdminUavPlatformRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteAdminUavPlatform().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/uav-platforms/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Видалення БпЛА в адміністративному інтерфейсі (м\'яке)
     * Видалення БпЛА
     */
    async deleteAdminUavPlatform(requestParameters: DeleteAdminUavPlatformRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAdminUavPlatformRaw(requestParameters, initOverrides);
    }

    /**
     * Видалення користувача в адміністративному інтерфейсі
     * Видалення користувача
     */
    async deleteAdminUserRaw(requestParameters: DeleteAdminUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteAdminUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/user/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Видалення користувача в адміністративному інтерфейсі
     * Видалення користувача
     */
    async deleteAdminUser(requestParameters: DeleteAdminUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAdminUserRaw(requestParameters, initOverrides);
    }

    /**
     * Видалення зони в адміністративному інтерфейсі
     * Видалення зони
     */
    async deleteAdminZoneRaw(requestParameters: DeleteAdminZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteAdminZone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/zone/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Видалення зони в адміністративному інтерфейсі
     * Видалення зони
     */
    async deleteAdminZone(requestParameters: DeleteAdminZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAdminZoneRaw(requestParameters, initOverrides);
    }

    /**
     * Вилучення FAQ запису
     */
    async deleteFAQRaw(requestParameters: DeleteFAQRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteFAQ().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/faq/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Вилучення FAQ запису
     */
    async deleteFAQ(requestParameters: DeleteFAQRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.deleteFAQRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Видалення історичної події
     */
    async deleteHistoryEventRaw(requestParameters: DeleteHistoryEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteHistoryEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/history-events/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Видалення історичної події
     */
    async deleteHistoryEvent(requestParameters: DeleteHistoryEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.deleteHistoryEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Прибирає найновіший (за seq) запис збиття заявки — виправлення помилкового внесення. Статус заявки НЕ відкочується
     * Видалення останнього запису в журналі збитих бортів
     */
    async deleteLastUavMissionShootdownRaw(requestParameters: DeleteLastUavMissionShootdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteLastUavMissionShootdown().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/uav-missions/{id}/shootdowns/last`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Прибирає найновіший (за seq) запис збиття заявки — виправлення помилкового внесення. Статус заявки НЕ відкочується
     * Видалення останнього запису в журналі збитих бортів
     */
    async deleteLastUavMissionShootdown(requestParameters: DeleteLastUavMissionShootdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.deleteLastUavMissionShootdownRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Видалення місії
     */
    async deleteMissionRaw(requestParameters: DeleteMissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteMission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/missions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Видалення місії
     */
    async deleteMission(requestParameters: DeleteMissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.deleteMissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Видалення новини
     */
    async deleteNewsRaw(requestParameters: DeleteNewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteNews().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/news/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Видалення новини
     */
    async deleteNews(requestParameters: DeleteNewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.deleteNewsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Видалення відео-посилання для екіпажу пілота
     */
    async deletePilotTeamVideoLinkRaw(requestParameters: DeletePilotTeamVideoLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deletePilotTeamVideoLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/pilot/team-video-links/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Видалення відео-посилання для екіпажу пілота
     */
    async deletePilotTeamVideoLink(requestParameters: DeletePilotTeamVideoLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePilotTeamVideoLinkRaw(requestParameters, initOverrides);
    }

    /**
     * Видалення позиції з перевіркою доступу через ACL
     * Видалення позиції
     */
    async deletePositionRaw(requestParameters: DeletePositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deletePosition().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/positions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Видалення позиції з перевіркою доступу через ACL
     * Видалення позиції
     */
    async deletePosition(requestParameters: DeletePositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePositionRaw(requestParameters, initOverrides);
    }

    /**
     * Видалення права
     */
    async deleteSystemPermissionRaw(requestParameters: DeleteSystemPermissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['name'] == null) {
            throw new runtime.RequiredError(
                'name',
                'Required parameter "name" was null or undefined when calling deleteSystemPermission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/system/permission/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters['name']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Видалення права
     */
    async deleteSystemPermission(requestParameters: DeleteSystemPermissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSystemPermissionRaw(requestParameters, initOverrides);
    }

    /**
     * Видалення цілі
     */
    async deleteTargetRaw(requestParameters: DeleteTargetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteTarget().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/targets/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Видалення цілі
     */
    async deleteTarget(requestParameters: DeleteTargetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.deleteTargetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Скасовує заявку на політ борта (м\'яке видалення). Дозволено лише до першого підйому: заявка має бути в статусі awaiting_launch, без нальоту й без записів про збиття — виліт, що вже відбувся, це історія, а не чернетка
     * Скасування uav-місії
     */
    async deleteUavMissionRaw(requestParameters: DeleteUavMissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteUavMission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/uav-missions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Скасовує заявку на політ борта (м\'яке видалення). Дозволено лише до першого підйому: заявка має бути в статусі awaiting_launch, без нальоту й без записів про збиття — виліт, що вже відбувся, це історія, а не чернетка
     * Скасування uav-місії
     */
    async deleteUavMission(requestParameters: DeleteUavMissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.deleteUavMissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Гасить червону пульсацію борта на мапі (ew_reported_at → NULL) після доповіді екіпажу, що подавлення більше немає. Нова доповідь у треді знову вмикає тривогу
     * Зняття тривоги РЕБ по заявці
     */
    async deleteUavMissionEwReportRaw(requestParameters: DeleteUavMissionEwReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteUavMissionEwReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/uav-missions/{id}/ew-report`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Гасить червону пульсацію борта на мапі (ew_reported_at → NULL) після доповіді екіпажу, що подавлення більше немає. Нова доповідь у треді знову вмикає тривогу
     * Зняття тривоги РЕБ по заявці
     */
    async deleteUavMissionEwReport(requestParameters: DeleteUavMissionEwReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.deleteUavMissionEwReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Обнуляє коло району: борт після цього долітає до кінця треку і розвертається, як бомбер (штатна анімація без баражування)
     * Прибирання району баражування
     */
    async deleteUavMissionLoiterAreaRaw(requestParameters: DeleteUavMissionLoiterAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteUavMissionLoiterArea().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/uav-missions/{id}/loiter-area`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Обнуляє коло району: борт після цього долітає до кінця треку і розвертається, як бомбер (штатна анімація без баражування)
     * Прибирання району баражування
     */
    async deleteUavMissionLoiterArea(requestParameters: DeleteUavMissionLoiterAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.deleteUavMissionLoiterAreaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * М\'яке видалення шаблону в межах підрозділу
     * Видалення шаблону заявки
     */
    async deleteUavMissionTemplateRaw(requestParameters: DeleteUavMissionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteUavMissionTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/uav-mission-templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * М\'яке видалення шаблону в межах підрозділу
     * Видалення шаблону заявки
     */
    async deleteUavMissionTemplate(requestParameters: DeleteUavMissionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.deleteUavMissionTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Видаляє WebAuthn credential користувача. Вимагає підтвердження через один з діючих методів двофакторки.
     * Видалити WebAuthn credential
     */
    async deleteWebAuthnCredentialRaw(requestParameters: DeleteWebAuthnCredentialRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling deleteWebAuthnCredential().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/two-factor/webauthn/delete`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputDeleteWebAuthnCredentialRequestToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Видаляє WebAuthn credential користувача. Вимагає підтвердження через один з діючих методів двофакторки.
     * Видалити WebAuthn credential
     */
    async deleteWebAuthnCredential(requestParameters: DeleteWebAuthnCredentialRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteWebAuthnCredentialRaw(requestParameters, initOverrides);
    }

    /**
     * Вимкнути конкретний метод двофакторної авторизації (TOTP або WebAuthn). Вимагає підтвердження через інший діючий метод.
     * Вимкнути метод 2FA
     */
    async disableTwoFactorRaw(requestParameters: DisableTwoFactorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputTwoFactorStatusResponse>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling disableTwoFactor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/two-factor/disable`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputDisableTwoFactorRequestToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputTwoFactorStatusResponseFromJSON(jsonValue));
    }

    /**
     * Вимкнути конкретний метод двофакторної авторизації (TOTP або WebAuthn). Вимагає підтвердження через інший діючий метод.
     * Вимкнути метод 2FA
     */
    async disableTwoFactor(requestParameters: DisableTwoFactorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputTwoFactorStatusResponse> {
        const response = await this.disableTwoFactorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Редагування результату місії
     */
    async editMissionResultRaw(requestParameters: EditMissionResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling editMissionResult().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling editMissionResult().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/missions/{id}/result`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputMissionResultToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Редагування результату місії
     */
    async editMissionResult(requestParameters: EditMissionResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.editMissionResultRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Редагування відео для місії
     */
    async editMissionVideoRaw(requestParameters: EditMissionVideoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling editMissionVideo().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling editMissionVideo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/missions/{id}/video`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputMissionVideoToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Редагування відео для місії
     */
    async editMissionVideo(requestParameters: EditMissionVideoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.editMissionVideoRaw(requestParameters, initOverrides);
    }

    /**
     * Редагування цілі
     */
    async editTargetHandlerRaw(requestParameters: EditTargetHandlerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling editTargetHandler().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling editTargetHandler().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/targets/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputTargetToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Редагування цілі
     */
    async editTargetHandler(requestParameters: EditTargetHandlerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.editTargetHandlerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Увімкнути двофакторну авторизацію для користувача
     * Увімкнути 2FA
     */
    async enableTwoFactorRaw(requestParameters: EnableTwoFactorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputTwoFactorStatusResponse>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling enableTwoFactor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/two-factor/enable`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputEnableTwoFactorRequestToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputTwoFactorStatusResponseFromJSON(jsonValue));
    }

    /**
     * Увімкнути двофакторну авторизацію для користувача
     * Увімкнути 2FA
     */
    async enableTwoFactor(requestParameters: EnableTwoFactorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputTwoFactorStatusResponse> {
        const response = await this.enableTwoFactorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Вихід підрозділу з зони, з ініціативи командира
     * Вихід підрозділу з зони
     */
    async exitFromZoneRaw(requestParameters: ExitFromZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['zone'] == null) {
            throw new runtime.RequiredError(
                'zone',
                'Required parameter "zone" was null or undefined when calling exitFromZone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/fly/zone/{zone}`.replace(`{${"zone"}}`, encodeURIComponent(String(requestParameters['zone']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Вихід підрозділу з зони, з ініціативи командира
     * Вихід підрозділу з зони
     */
    async exitFromZone(requestParameters: ExitFromZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.exitFromZoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Завершення сесії бойового чергування, використовується для ручного дотермінового завершення сесії командиром
     * Завершення сесії
     */
    async finishSessionRaw(requestParameters: FinishSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling finishSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/session/finish-session/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Завершення сесії бойового чергування, використовується для ручного дотермінового завершення сесії командиром
     * Завершення сесії
     */
    async finishSession(requestParameters: FinishSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.finishSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Генерує новий TOTP secret та QR код для налаштування
     * Генерація TOTP secret та QR коду
     */
    async generateTotpSecretRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputTotpSecretResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/two-factor/totp/generate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputTotpSecretResponseFromJSON(jsonValue));
    }

    /**
     * Генерує новий TOTP secret та QR код для налаштування
     * Генерація TOTP secret та QR коду
     */
    async generateTotpSecret(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputTotpSecretResponse> {
        const response = await this.generateTotpSecretRaw(initOverrides);
        return await response.value();
    }

    /**
     * Генерує challenge для верифікації при вимкненні/видаленні методів 2FA
     * Генерація challenge для верифікації
     */
    async generateVerificationChallengeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputVerificationChallengeResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/two-factor/verification-challenge`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputVerificationChallengeResponseFromJSON(jsonValue));
    }

    /**
     * Генерує challenge для верифікації при вимкненні/видаленні методів 2FA
     * Генерація challenge для верифікації
     */
    async generateVerificationChallenge(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputVerificationChallengeResponse> {
        const response = await this.generateVerificationChallengeRaw(initOverrides);
        return await response.value();
    }

    /**
     * Зворотне геокодування точок маршруту по локальному газетиру (geo_places): для кожної точки — найближчий НП, плюс готовий опис маршруту словами. OPSEC: без зовнішніх геосервісів.
     * Назви НП за координатами
     */
    async geocodeReverseRaw(requestParameters: GeocodeReverseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputGeoReverse>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling geocodeReverse().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/geocode/reverse`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputGeoReverseToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputGeoReverseFromJSON(jsonValue));
    }

    /**
     * Зворотне геокодування точок маршруту по локальному газетиру (geo_places): для кожної точки — найближчий НП, плюс готовий опис маршруту словами. OPSEC: без зовнішніх геосервісів.
     * Назви НП за координатами
     */
    async geocodeReverse(requestParameters: GeocodeReverseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputGeoReverse> {
        const response = await this.geocodeReverseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Type-ahead по локальному газетиру НП (geo_places). lat/lon задають пріоритет поблизу центру мапи (postgis KNN). OPSEC: без зовнішніх геосервісів.
     * Пошук населеного пункту
     */
    async geocodeSearchRaw(requestParameters: GeocodeSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputGeoPlace>>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling geocodeSearch().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['lat'] != null) {
            queryParameters['lat'] = requestParameters['lat'];
        }

        if (requestParameters['lon'] != null) {
            queryParameters['lon'] = requestParameters['lon'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/geocode`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputGeoPlaceFromJSON));
    }

    /**
     * Type-ahead по локальному газетиру НП (geo_places). lat/lon задають пріоритет поблизу центру мапи (postgis KNN). OPSEC: без зовнішніх геосервісів.
     * Пошук населеного пункту
     */
    async geocodeSearch(requestParameters: GeocodeSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputGeoPlace>> {
        const response = await this.geocodeSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання інформації про БК в адміністративному інтерфейсі
     * Отримання БК
     */
    async getAdminAmmoRaw(requestParameters: GetAdminAmmoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputAdminAmmo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAdminAmmo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/ammo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputAdminAmmoFromJSON(jsonValue));
    }

    /**
     * Отримання інформації про БК в адміністративному інтерфейсі
     * Отримання БК
     */
    async getAdminAmmo(requestParameters: GetAdminAmmoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputAdminAmmo> {
        const response = await this.getAdminAmmoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку БК підрозділу в адміністративному інтерфейсі
     * Отримання списку БК
     */
    async getAdminAmmoListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputAdminAmmo>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/ammo`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputAdminAmmoFromJSON));
    }

    /**
     * Отримання списку БК підрозділу в адміністративному інтерфейсі
     * Отримання списку БК
     */
    async getAdminAmmoList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputAdminAmmo>> {
        const response = await this.getAdminAmmoListRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання інформації про бригаду в адміністративному інтерфейсі
     * Отримання бригади
     */
    async getAdminBrigadeRaw(requestParameters: GetAdminBrigadeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputAdminBrigade>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAdminBrigade().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/brigade/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputAdminBrigadeFromJSON(jsonValue));
    }

    /**
     * Отримання інформації про бригаду в адміністративному інтерфейсі
     * Отримання бригади
     */
    async getAdminBrigade(requestParameters: GetAdminBrigadeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputAdminBrigade> {
        const response = await this.getAdminBrigadeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку доступних користувачу бригад в адміністративному інтерфейсі
     * Отримання доступних бригад
     */
    async getAdminBrigadesRaw(requestParameters: GetAdminBrigadesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputAdminBrigade>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sort_by'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['order_by'] = requestParameters['orderBy'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/brigades`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputAdminBrigadeFromJSON));
    }

    /**
     * Отримання списку доступних користувачу бригад в адміністративному інтерфейсі
     * Отримання доступних бригад
     */
    async getAdminBrigades(requestParameters: GetAdminBrigadesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputAdminBrigade>> {
        const response = await this.getAdminBrigadesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання інформації про чат
     */
    async getAdminChatChannelRaw(requestParameters: GetAdminChatChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputAdminChatChannel>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAdminChatChannel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/chat_channel/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputAdminChatChannelFromJSON(jsonValue));
    }

    /**
     * Отримання інформації про чат
     */
    async getAdminChatChannel(requestParameters: GetAdminChatChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputAdminChatChannel> {
        const response = await this.getAdminChatChannelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Список чатів
     */
    async getAdminChatsRaw(requestParameters: GetAdminChatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputAdminChatChannel>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sort_by'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['order_by'] = requestParameters['orderBy'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/chats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputAdminChatChannelFromJSON));
    }

    /**
     * Список чатів
     */
    async getAdminChats(requestParameters: GetAdminChatsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputAdminChatChannel>> {
        const response = await this.getAdminChatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання інформації про підрозділ в адміністративному інтерфейсі
     * Отримання інформації про підрозділ
     */
    async getAdminDivisionRaw(requestParameters: GetAdminDivisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputAdminDivision>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAdminDivision().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/division/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputAdminDivisionFromJSON(jsonValue));
    }

    /**
     * Отримання інформації про підрозділ в адміністративному інтерфейсі
     * Отримання інформації про підрозділ
     */
    async getAdminDivision(requestParameters: GetAdminDivisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputAdminDivision> {
        const response = await this.getAdminDivisionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку доступних користувачу підрозділів в адміністративному інтерфейсі
     * Отримання доступних підрозділів
     */
    async getAdminDivisionsRaw(requestParameters: GetAdminDivisionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputAdminDivision>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sort_by'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['order_by'] = requestParameters['orderBy'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/divisions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputAdminDivisionFromJSON));
    }

    /**
     * Отримання списку доступних користувачу підрозділів в адміністративному інтерфейсі
     * Отримання доступних підрозділів
     */
    async getAdminDivisions(requestParameters: GetAdminDivisionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputAdminDivision>> {
        const response = await this.getAdminDivisionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Поточний стан авторизації Element/Matrix-бота (без секретів)
     * Стан сесії Element-бота
     */
    async getAdminElementSessionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputAdminElementSession>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/element/session`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputAdminElementSessionFromJSON(jsonValue));
    }

    /**
     * Поточний стан авторизації Element/Matrix-бота (без секретів)
     * Стан сесії Element-бота
     */
    async getAdminElementSession(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputAdminElementSession> {
        const response = await this.getAdminElementSessionRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання доступних пілотів в підрозділі
     */
    async getAdminGetDivisionFreePilotsRaw(requestParameters: GetAdminGetDivisionFreePilotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputUserShort>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAdminGetDivisionFreePilots().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/division/{id}/free-pilots`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputUserShortFromJSON));
    }

    /**
     * Отримання доступних пілотів в підрозділі
     */
    async getAdminGetDivisionFreePilots(requestParameters: GetAdminGetDivisionFreePilotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputUserShort>> {
        const response = await this.getAdminGetDivisionFreePilotsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання усіх новин
     */
    async getAdminNewsRaw(requestParameters: GetAdminNewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputNews>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sort_by'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['order_by'] = requestParameters['orderBy'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/news`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputNewsFromJSON));
    }

    /**
     * Отримання усіх новин
     */
    async getAdminNews(requestParameters: GetAdminNewsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputNews>> {
        const response = await this.getAdminNewsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання інформації про ОСУВ в адміністративному інтерфейсі
     * Отримання ОСУВ
     */
    async getAdminOSGRaw(requestParameters: GetAdminOSGRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputAdminOSG>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAdminOSG().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/osg/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputAdminOSGFromJSON(jsonValue));
    }

    /**
     * Отримання інформації про ОСУВ в адміністративному інтерфейсі
     * Отримання ОСУВ
     */
    async getAdminOSG(requestParameters: GetAdminOSGRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputAdminOSG> {
        const response = await this.getAdminOSGRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку доступних користувачу ОСУВ в адміністративному інтерфейсі
     * Отримання доступних ОСУВ
     */
    async getAdminOSGsRaw(requestParameters: GetAdminOSGsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputAdminOSG>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sort_by'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['order_by'] = requestParameters['orderBy'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/osgs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputAdminOSGFromJSON));
    }

    /**
     * Отримання списку доступних користувачу ОСУВ в адміністративному інтерфейсі
     * Отримання доступних ОСУВ
     */
    async getAdminOSGs(requestParameters: GetAdminOSGsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputAdminOSG>> {
        const response = await this.getAdminOSGsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання інформації про корпус в адміністративному інтерфейсі
     * Отримання корпусу
     */
    async getAdminOTGRaw(requestParameters: GetAdminOTGRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputAdminOTG>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAdminOTG().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/otg/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputAdminOTGFromJSON(jsonValue));
    }

    /**
     * Отримання інформації про корпус в адміністративному інтерфейсі
     * Отримання корпусу
     */
    async getAdminOTG(requestParameters: GetAdminOTGRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputAdminOTG> {
        const response = await this.getAdminOTGRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Межі одного корпусу у форматі GeoJSON Feature (MultiPolygon). 204 — межі ще не задано
     * Отримання полігона корпусу
     */
    async getAdminOTGPolygonRaw(requestParameters: GetAdminOTGPolygonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputGeoJsonFeature>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAdminOTGPolygon().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/otg/{id}/polygon`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputGeoJsonFeatureFromJSON(jsonValue));
    }

    /**
     * Межі одного корпусу у форматі GeoJSON Feature (MultiPolygon). 204 — межі ще не задано
     * Отримання полігона корпусу
     */
    async getAdminOTGPolygon(requestParameters: GetAdminOTGPolygonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputGeoJsonFeature | null | undefined > {
        const response = await this.getAdminOTGPolygonRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Межі всіх корпусів у форматі GeoJSON. Шар адміністративний: використовується для редагування меж і надалі — для визначення корпусу-отримувача заявки БпЛА
     * Отримання полігонів корпусів
     */
    async getAdminOTGPolygonsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputGeoJson>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/otgs/polygons`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputGeoJsonFromJSON(jsonValue));
    }

    /**
     * Межі всіх корпусів у форматі GeoJSON. Шар адміністративний: використовується для редагування меж і надалі — для визначення корпусу-отримувача заявки БпЛА
     * Отримання полігонів корпусів
     */
    async getAdminOTGPolygons(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputGeoJson> {
        const response = await this.getAdminOTGPolygonsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку доступних користувачу корпусів в адміністративному інтерфейсі
     * Отримання доступних корпусів
     */
    async getAdminOTGsRaw(requestParameters: GetAdminOTGsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputAdminOTG>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sort_by'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['order_by'] = requestParameters['orderBy'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/otgs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputAdminOTGFromJSON));
    }

    /**
     * Отримання списку доступних користувачу корпусів в адміністративному інтерфейсі
     * Отримання доступних корпусів
     */
    async getAdminOTGs(requestParameters: GetAdminOTGsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputAdminOTG>> {
        const response = await this.getAdminOTGsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання балансу та історії рухів засобів для позиції
     * Отримання обліку засобів на позиції
     */
    async getAdminPositionStockRaw(requestParameters: GetAdminPositionStockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputAdminPositionStockResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAdminPositionStock().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['stockType'] != null) {
            queryParameters['stockType'] = requestParameters['stockType'];
        }

        if (requestParameters['stockItemId'] != null) {
            queryParameters['stockItemId'] = requestParameters['stockItemId'];
        }

        if (requestParameters['movementType'] != null) {
            queryParameters['movementType'] = requestParameters['movementType'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/positions/{id}/stock`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputAdminPositionStockResponseFromJSON(jsonValue));
    }

    /**
     * Отримання балансу та історії рухів засобів для позиції
     * Отримання обліку засобів на позиції
     */
    async getAdminPositionStock(requestParameters: GetAdminPositionStockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputAdminPositionStockResponse> {
        const response = await this.getAdminPositionStockRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання інформації про сесію бойового чергування
     */
    async getAdminSessionInfoRaw(requestParameters: GetAdminSessionInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputAdminDetailedSession>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAdminSessionInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/detailed-session-info/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputAdminDetailedSessionFromJSON(jsonValue));
    }

    /**
     * Отримання інформації про сесію бойового чергування
     */
    async getAdminSessionInfo(requestParameters: GetAdminSessionInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputAdminDetailedSession> {
        const response = await this.getAdminSessionInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання сесій бойового чергування в адміністративному інтерфейсі
     */
    async getAdminSessionsRaw(requestParameters: GetAdminSessionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputAdminSession>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sort_by'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['order_by'] = requestParameters['orderBy'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/sessions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputAdminSessionFromJSON));
    }

    /**
     * Отримання сесій бойового чергування в адміністративному інтерфейсі
     */
    async getAdminSessions(requestParameters: GetAdminSessionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputAdminSession>> {
        const response = await this.getAdminSessionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання інформації про засіб в адміністративному інтерфейсі
     * Отримання засобу
     */
    async getAdminStockItemRaw(requestParameters: GetAdminStockItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputAdminStockItem>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAdminStockItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/stock-items/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputAdminStockItemFromJSON(jsonValue));
    }

    /**
     * Отримання інформації про засіб в адміністративному інтерфейсі
     * Отримання засобу
     */
    async getAdminStockItem(requestParameters: GetAdminStockItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputAdminStockItem> {
        const response = await this.getAdminStockItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку засобів (дрони/боєкомплекти) в адміністративному інтерфейсі з фільтрацією, пагінацією та сортуванням
     * Отримання списку засобів
     */
    async getAdminStockItemsRaw(requestParameters: GetAdminStockItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputAdminStockItem>>> {
        const queryParameters: any = {};

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sort_by'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['order_by'] = requestParameters['orderBy'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/stock-items`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputAdminStockItemFromJSON));
    }

    /**
     * Отримання списку засобів (дрони/боєкомплекти) в адміністративному інтерфейсі з фільтрацією, пагінацією та сортуванням
     * Отримання списку засобів
     */
    async getAdminStockItems(requestParameters: GetAdminStockItemsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputAdminStockItem>> {
        const response = await this.getAdminStockItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання інформації про екіпаж в адміністративному інтерфейсі
     * Отримання інформації про екіпаж
     */
    async getAdminTeamRaw(requestParameters: GetAdminTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputAdminTeam>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAdminTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/team/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputAdminTeamFromJSON(jsonValue));
    }

    /**
     * Отримання інформації про екіпаж в адміністративному інтерфейсі
     * Отримання інформації про екіпаж
     */
    async getAdminTeam(requestParameters: GetAdminTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputAdminTeam> {
        const response = await this.getAdminTeamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання інформації про сесію екіпажу
     */
    async getAdminTeamSessionRaw(requestParameters: GetAdminTeamSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputTeamSessionInfo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAdminTeamSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/team/{id}/session`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputTeamSessionInfoFromJSON(jsonValue));
    }

    /**
     * Отримання інформації про сесію екіпажу
     */
    async getAdminTeamSession(requestParameters: GetAdminTeamSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputTeamSessionInfo> {
        const response = await this.getAdminTeamSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку відео-посилань для заданого екіпажу
     * Відео-посилання екіпажу (адмін)
     */
    async getAdminTeamVideoLinksRaw(requestParameters: GetAdminTeamVideoLinksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputOutputTeamVideoLink>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAdminTeamVideoLinks().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/teams/{id}/video-links`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputOutputTeamVideoLinkFromJSON));
    }

    /**
     * Отримання списку відео-посилань для заданого екіпажу
     * Відео-посилання екіпажу (адмін)
     */
    async getAdminTeamVideoLinks(requestParameters: GetAdminTeamVideoLinksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputOutputTeamVideoLink>> {
        const response = await this.getAdminTeamVideoLinksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку доступних користувачу екіпажів в адміністративному інтерфейсі
     * Отримання доступних екіпажів
     */
    async getAdminTeamsRaw(requestParameters: GetAdminTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputAdminTeam>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sort_by'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['order_by'] = requestParameters['orderBy'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/teams`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputAdminTeamFromJSON));
    }

    /**
     * Отримання списку доступних користувачу екіпажів в адміністративному інтерфейсі
     * Отримання доступних екіпажів
     */
    async getAdminTeams(requestParameters: GetAdminTeamsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputAdminTeam>> {
        const response = await this.getAdminTeamsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку доступних зон для форми редагування екіпажів
     * Отримання доступних зон
     */
    async getAdminTeamsZonesForSelectorRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputAdminTeamsZonesSelector>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/teams/zones-selector`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputAdminTeamsZonesSelectorFromJSON));
    }

    /**
     * Отримання списку доступних зон для форми редагування екіпажів
     * Отримання доступних зон
     */
    async getAdminTeamsZonesForSelector(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputAdminTeamsZonesSelector>> {
        const response = await this.getAdminTeamsZonesForSelectorRaw(initOverrides);
        return await response.value();
    }

    /**
     * Користувачі підрозділу з роллю uav_crew, ще не включені до жодного екіпажу БпЛА (крім поточного).
     * Кандидати до складу екіпажу БпЛА
     */
    async getAdminUavCrewCandidatesRaw(requestParameters: GetAdminUavCrewCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputUserShort>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAdminUavCrewCandidates().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/team/{id}/uav-crew-candidates`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputUserShortFromJSON));
    }

    /**
     * Користувачі підрозділу з роллю uav_crew, ще не включені до жодного екіпажу БпЛА (крім поточного).
     * Кандидати до складу екіпажу БпЛА
     */
    async getAdminUavCrewCandidates(requestParameters: GetAdminUavCrewCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputUserShort>> {
        const response = await this.getAdminUavCrewCandidatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання інформації про БпЛА в адміністративному інтерфейсі
     * Отримання БпЛА
     */
    async getAdminUavPlatformRaw(requestParameters: GetAdminUavPlatformRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputAdminUavPlatform>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAdminUavPlatform().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/uav-platforms/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputAdminUavPlatformFromJSON(jsonValue));
    }

    /**
     * Отримання інформації про БпЛА в адміністративному інтерфейсі
     * Отримання БпЛА
     */
    async getAdminUavPlatform(requestParameters: GetAdminUavPlatformRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputAdminUavPlatform> {
        const response = await this.getAdminUavPlatformRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання довідника БпЛА в адміністративному інтерфейсі з фільтрацією, пагінацією та сортуванням
     * Отримання списку БпЛА
     */
    async getAdminUavPlatformsRaw(requestParameters: GetAdminUavPlatformsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputAdminUavPlatform>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sort_by'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['order_by'] = requestParameters['orderBy'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/uav-platforms`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputAdminUavPlatformFromJSON));
    }

    /**
     * Отримання довідника БпЛА в адміністративному інтерфейсі з фільтрацією, пагінацією та сортуванням
     * Отримання списку БпЛА
     */
    async getAdminUavPlatforms(requestParameters: GetAdminUavPlatformsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputAdminUavPlatform>> {
        const response = await this.getAdminUavPlatformsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Постійний склад екіпажу БпЛА. На відміну від FPV, склад не залежить від бойового чергування — саме за ним члени екіпажу отримують доступ до подачі заявок.
     * Склад екіпажу БпЛА
     */
    async getAdminUavTeamMembersRaw(requestParameters: GetAdminUavTeamMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputUavCrewMember>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAdminUavTeamMembers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/team/{id}/uav-members`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputUavCrewMemberFromJSON));
    }

    /**
     * Постійний склад екіпажу БпЛА. На відміну від FPV, склад не залежить від бойового чергування — саме за ним члени екіпажу отримують доступ до подачі заявок.
     * Склад екіпажу БпЛА
     */
    async getAdminUavTeamMembers(requestParameters: GetAdminUavTeamMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputUavCrewMember>> {
        const response = await this.getAdminUavTeamMembersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Сталі параметри вильоту екіпажу БпЛА
     */
    async getAdminUavTeamSettingsRaw(requestParameters: GetAdminUavTeamSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputUavCrewSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAdminUavTeamSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/team/{id}/uav-settings`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputUavCrewSettingsFromJSON(jsonValue));
    }

    /**
     * Сталі параметри вильоту екіпажу БпЛА
     */
    async getAdminUavTeamSettings(requestParameters: GetAdminUavTeamSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputUavCrewSettings> {
        const response = await this.getAdminUavTeamSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Групи заявок, у яких платформу не змапило на довідник (uav_platform_id IS NULL), згруповані за нормалізованим ключем назви й відсортовані за кількістю. Підказка адміну, які борти додати. Групи, що вже матчаться на поточний довідник, виключено.
     * Аналіз нерозпізнаних платформ
     */
    async getAdminUnrecognizedUavPlatformsRaw(requestParameters: GetAdminUnrecognizedUavPlatformsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputUnrecognizedUavPlatform>>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/unrecognized-uav-platforms`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputUnrecognizedUavPlatformFromJSON));
    }

    /**
     * Групи заявок, у яких платформу не змапило на довідник (uav_platform_id IS NULL), згруповані за нормалізованим ключем назви й відсортовані за кількістю. Підказка адміну, які борти додати. Групи, що вже матчаться на поточний довідник, виключено.
     * Аналіз нерозпізнаних платформ
     */
    async getAdminUnrecognizedUavPlatforms(requestParameters: GetAdminUnrecognizedUavPlatformsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputUnrecognizedUavPlatform>> {
        const response = await this.getAdminUnrecognizedUavPlatformsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання інформації про користувача в адміністративному інтерфейсі
     * Отримання інформації про користувача
     */
    async getAdminUserRaw(requestParameters: GetAdminUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputAdminUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAdminUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/user/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputAdminUserFromJSON(jsonValue));
    }

    /**
     * Отримання інформації про користувача в адміністративному інтерфейсі
     * Отримання інформації про користувача
     */
    async getAdminUser(requestParameters: GetAdminUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputAdminUser> {
        const response = await this.getAdminUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку доступних корпусів для форми редагування користувача
     * Отримання корпусів
     */
    async getAdminUserOtgsForSelectorRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputAdminUsersOtgsSelector>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/users/selector-otgs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputAdminUsersOtgsSelectorFromJSON));
    }

    /**
     * Отримання списку доступних корпусів для форми редагування користувача
     * Отримання корпусів
     */
    async getAdminUserOtgsForSelector(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputAdminUsersOtgsSelector>> {
        const response = await this.getAdminUserOtgsForSelectorRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання ролей для керування користувачем в адміністративному інтерфейсі
     * Список ролей
     */
    async getAdminUserRolesForSelectorRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputAdminRoleSelector>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/users/selector-roles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputAdminRoleSelectorFromJSON));
    }

    /**
     * Отримання ролей для керування користувачем в адміністративному інтерфейсі
     * Список ролей
     */
    async getAdminUserRolesForSelector(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputAdminRoleSelector>> {
        const response = await this.getAdminUserRolesForSelectorRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку доступних зон для форми редагування користувача
     * Отримання зон
     */
    async getAdminUserZonesForSelectorRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputAdminUsersZonesSelector>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/users/selector-zones`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputAdminUsersZonesSelectorFromJSON));
    }

    /**
     * Отримання списку доступних зон для форми редагування користувача
     * Отримання зон
     */
    async getAdminUserZonesForSelector(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputAdminUsersZonesSelector>> {
        const response = await this.getAdminUserZonesForSelectorRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку доступних користувачу користувачів в адміністративному інтерфейсі
     * Отримання доступних користувачів
     */
    async getAdminUsersRaw(requestParameters: GetAdminUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputAdminUser>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sort_by'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['order_by'] = requestParameters['orderBy'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/users`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputAdminUserFromJSON));
    }

    /**
     * Отримання списку доступних користувачу користувачів в адміністративному інтерфейсі
     * Отримання доступних користувачів
     */
    async getAdminUsers(requestParameters: GetAdminUsersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputAdminUser>> {
        const response = await this.getAdminUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання інформації про зону в адміністративному інтерфейсі
     * Отримання зони
     */
    async getAdminZoneRaw(requestParameters: GetAdminZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputAdminZone>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAdminZone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/zone/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputAdminZoneFromJSON(jsonValue));
    }

    /**
     * Отримання інформації про зону в адміністративному інтерфейсі
     * Отримання зони
     */
    async getAdminZone(requestParameters: GetAdminZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputAdminZone> {
        const response = await this.getAdminZoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку доступних користувачу зон в адміністративному інтерфейсі
     * Отримання доступних зон
     */
    async getAdminZonesRaw(requestParameters: GetAdminZonesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputAdminZone>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sort_by'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['order_by'] = requestParameters['orderBy'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/zones`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputAdminZoneFromJSON));
    }

    /**
     * Отримання списку доступних користувачу зон в адміністративному інтерфейсі
     * Отримання доступних зон
     */
    async getAdminZones(requestParameters: GetAdminZonesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputAdminZone>> {
        const response = await this.getAdminZonesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку вільних каналів з preferred_channels для заміни зайнятих
     * Отримати альтернативні вільні канали
     */
    async getAlternativeChannelsRaw(requestParameters: GetAlternativeChannelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputAlternativeChannelsResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAlternativeChannels().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/mission/{id}/alternative-channels`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputAlternativeChannelsResponseFromJSON(jsonValue));
    }

    /**
     * Отримання списку вільних каналів з preferred_channels для заміни зайнятих
     * Отримати альтернативні вільні канали
     */
    async getAlternativeChannels(requestParameters: GetAlternativeChannelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputAlternativeChannelsResponse> {
        const response = await this.getAlternativeChannelsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Список БК для autocomplete-елементу в фільтрах
     */
    async getAmmoListForFilterRaw(requestParameters: GetAmmoListForFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputFiltersSelectStringItem>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/filters/ammo`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputFiltersSelectStringItemFromJSON));
    }

    /**
     * Список БК для autocomplete-елементу в фільтрах
     */
    async getAmmoListForFilter(requestParameters: GetAmmoListForFilterRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputFiltersSelectStringItem>> {
        const response = await this.getAmmoListForFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку БК підрозділу в інтерфейсі історії
     * Отримання списку БК для місії
     */
    async getAmmoListForMissionRaw(requestParameters: GetAmmoListForMissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputAmmo>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAmmoListForMission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/missions/{id}/ammo`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputAmmoFromJSON));
    }

    /**
     * Отримання списку БК підрозділу в інтерфейсі історії
     * Отримання списку БК для місії
     */
    async getAmmoListForMission(requestParameters: GetAmmoListForMissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputAmmo>> {
        const response = await this.getAmmoListForMissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Теплова карта використання каналів
     */
    async getAnalyticsChannelHeatmapRaw(requestParameters: GetAnalyticsChannelHeatmapRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputAnalyticsChannelHeatmapItem>>> {
        if (requestParameters['search'] == null) {
            throw new runtime.RequiredError(
                'search',
                'Required parameter "search" was null or undefined when calling getAnalyticsChannelHeatmap().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/analytics/channel-heatmap`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputAnalyticsChannelHeatmapItemFromJSON));
    }

    /**
     * Теплова карта використання каналів
     */
    async getAnalyticsChannelHeatmap(requestParameters: GetAnalyticsChannelHeatmapRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputAnalyticsChannelHeatmapItem>> {
        const response = await this.getAnalyticsChannelHeatmapRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Завантаження інформації по місіям
     */
    async getAnalyticsMissionsRaw(requestParameters: GetAnalyticsMissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputAnalyticsMissionsDataItem>>> {
        if (requestParameters['search'] == null) {
            throw new runtime.RequiredError(
                'search',
                'Required parameter "search" was null or undefined when calling getAnalyticsMissions().'
            );
        }

        if (requestParameters['groupBy'] == null) {
            throw new runtime.RequiredError(
                'groupBy',
                'Required parameter "groupBy" was null or undefined when calling getAnalyticsMissions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['chart'] != null) {
            queryParameters['chart'] = requestParameters['chart'];
        }

        if (requestParameters['groupBy'] != null) {
            queryParameters['group_by'] = requestParameters['groupBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/analytics/missions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputAnalyticsMissionsDataItemFromJSON));
    }

    /**
     * Завантаження інформації по місіям
     */
    async getAnalyticsMissions(requestParameters: GetAnalyticsMissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputAnalyticsMissionsDataItem>> {
        const response = await this.getAnalyticsMissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання centrifugo токена
     */
    async getAuthCentrifugoTokenRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/auth/centrifugo_token`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Отримання centrifugo токена
     */
    async getAuthCentrifugoToken(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getAuthCentrifugoTokenRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку доступних привілегій, для перевірки доступності елементів в застосунку
     * Отримання привілегій
     */
    async getAuthPermissionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/auth/permissions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Отримання списку доступних привілегій, для перевірки доступності елементів в застосунку
     * Отримання привілегій
     */
    async getAuthPermissions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getAuthPermissionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання сесійної інформації про залогіненого користувача
     * Перевірка стану аутентифікації
     */
    async getAuthSessionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputUserIdentity>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/auth/session`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputUserIdentityFromJSON(jsonValue));
    }

    /**
     * Отримання сесійної інформації про залогіненого користувача
     * Перевірка стану аутентифікації
     */
    async getAuthSession(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputUserIdentity> {
        const response = await this.getAuthSessionRaw(initOverrides);
        return await response.value();
    }

    /**
     * Спеціальний хеш токену, який надає доступ до створення потоку на іншому домені, так як із за proxy SSE не працюютть
     * Отримання хешу токена
     */
    async getAuthStreamTokenRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/auth/stream_token`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Спеціальний хеш токену, який надає доступ до створення потоку на іншому домені, так як із за proxy SSE не працюютть
     * Отримання хешу токена
     */
    async getAuthStreamToken(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getAuthStreamTokenRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання токена доступу для авторизації в застосунку. Якщо у користувача увімкнено 2FA, повертає вимогу верифікації з challenge. Токен встановлюється в httpOnly cookie.
     * Отримання токена доступу
     */
    async getAuthTokenRaw(requestParameters: GetAuthTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputAuthTokenResponse>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling getAuthToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/auth/token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputAuthTokenToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputAuthTokenResponseFromJSON(jsonValue));
    }

    /**
     * Отримання токена доступу для авторизації в застосунку. Якщо у користувача увімкнено 2FA, повертає вимогу верифікації з challenge. Токен встановлюється в httpOnly cookie.
     * Отримання токена доступу
     */
    async getAuthToken(requestParameters: GetAuthTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputAuthTokenResponse> {
        const response = await this.getAuthTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання даних поточної місії
     * Активна місія
     */
    async getBookingDataRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputBookingData>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/fly/booking-data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputBookingDataFromJSON(jsonValue));
    }

    /**
     * Отримання даних поточної місії
     * Активна місія
     */
    async getBookingData(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputBookingData> {
        const response = await this.getBookingDataRaw(initOverrides);
        return await response.value();
    }

    /**
     * Бригади для autocomplete-елементу в фільтрах
     */
    async getBrigadesForFilterRaw(requestParameters: GetBrigadesForFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputFiltersSelectItem>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/filters/brigades`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputFiltersSelectItemFromJSON));
    }

    /**
     * Бригади для autocomplete-елементу в фільтрах
     */
    async getBrigadesForFilter(requestParameters: GetBrigadesForFilterRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputFiltersSelectItem>> {
        const response = await this.getBrigadesForFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання всіх можливих комбінацій діапазонів і каналів
     */
    async getChannelDefinitionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputChannelDefinitionItem>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/analytics/channel-definitions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputChannelDefinitionItemFromJSON));
    }

    /**
     * Отримання всіх можливих комбінацій діапазонів і каналів
     */
    async getChannelDefinitions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputChannelDefinitionItem>> {
        const response = await this.getChannelDefinitionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Сітка частот
     */
    async getChannelsMapRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputChannelsMap>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/fly/channels-map`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputChannelsMapFromJSON(jsonValue));
    }

    /**
     * Сітка частот
     */
    async getChannelsMap(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputChannelsMap> {
        const response = await this.getChannelsMapRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання доступних чатів
     */
    async getChatChannelsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputChatChannel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/chat/channels`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputChatChannelFromJSON));
    }

    /**
     * Отримання доступних чатів
     */
    async getChatChannels(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputChatChannel>> {
        const response = await this.getChatChannelsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання повідомлень
     */
    async getChatMessagesRaw(requestParameters: GetChatMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputChatMessage>>> {
        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling getChatMessages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['beforeMessageId'] != null) {
            queryParameters['before_message_id'] = requestParameters['beforeMessageId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/chat/{channel_id}/messages`.replace(`{${"channel_id"}}`, encodeURIComponent(String(requestParameters['channelId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputChatMessageFromJSON));
    }

    /**
     * Отримання повідомлень
     */
    async getChatMessages(requestParameters: GetChatMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputChatMessage>> {
        const response = await this.getChatMessagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримує статуси прочитаності для всіх доступних каналів.
     */
    async getChatReadStatusesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputChatChannelReadStatus>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/chat/read-statuses`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputChatChannelReadStatusFromJSON));
    }

    /**
     * Отримує статуси прочитаності для всіх доступних каналів.
     */
    async getChatReadStatuses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputChatChannelReadStatus>> {
        const response = await this.getChatReadStatusesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Напрямки польоту для autocomplete-елементу в фільтрах
     */
    async getDirectionsForFilterRaw(requestParameters: GetDirectionsForFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputFiltersSelectStringItem>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/filters/directions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputFiltersSelectStringItemFromJSON));
    }

    /**
     * Напрямки польоту для autocomplete-елементу в фільтрах
     */
    async getDirectionsForFilter(requestParameters: GetDirectionsForFilterRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputFiltersSelectStringItem>> {
        const response = await this.getDirectionsForFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання підрозділів ( RESTFul модель)
     */
    async getDivisionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputAdminDivision>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/divisions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputAdminDivisionFromJSON));
    }

    /**
     * Отримання підрозділів ( RESTFul модель)
     */
    async getDivisions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputAdminDivision>> {
        const response = await this.getDivisionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Підрозділи для autocomplete-елементу в фільтрах
     */
    async getDivisionsForFilterRaw(requestParameters: GetDivisionsForFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputFiltersSelectItem>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/filters/divisions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputFiltersSelectItemFromJSON));
    }

    /**
     * Підрозділи для autocomplete-елементу в фільтрах
     */
    async getDivisionsForFilter(requestParameters: GetDivisionsForFilterRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputFiltersSelectItem>> {
        const response = await this.getDivisionsForFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Список дронів для autocomplete-елементу в фільтрах
     */
    async getDroneListForFilterRaw(requestParameters: GetDroneListForFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputFiltersSelectStringItem>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/filters/drone`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputFiltersSelectStringItemFromJSON));
    }

    /**
     * Список дронів для autocomplete-елементу в фільтрах
     */
    async getDroneListForFilter(requestParameters: GetDroneListForFilterRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputFiltersSelectStringItem>> {
        const response = await this.getDroneListForFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку дублікатів підрозділів та їх екіпажів
     * Отримання дублікатів підрозділів
     */
    async getDuplicateDivisionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputDuplicateDivision>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/merger/duplicates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputDuplicateDivisionFromJSON));
    }

    /**
     * Отримання списку дублікатів підрозділів та їх екіпажів
     * Отримання дублікатів підрозділів
     */
    async getDuplicateDivisions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputDuplicateDivision>> {
        const response = await this.getDuplicateDivisionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання популярних та захардкожених діапазонів частот
     * Рекомендовані діапазони частот
     */
    async getEwFrequencySuggestionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputEwFrequencySuggestions>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/ew/frequency-suggestions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputEwFrequencySuggestionsFromJSON(jsonValue));
    }

    /**
     * Отримання популярних та захардкожених діапазонів частот
     * Рекомендовані діапазони частот
     */
    async getEwFrequencySuggestions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputEwFrequencySuggestions> {
        const response = await this.getEwFrequencySuggestionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку активних та запланованих сесій подавлення для зон корпусу
     * Список сесій подавлення
     */
    async getEwSuppressionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputEwSuppressionSessionsList>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/ew/suppressions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputEwSuppressionSessionsListFromJSON(jsonValue));
    }

    /**
     * Отримання списку активних та запланованих сесій подавлення для зон корпусу
     * Список сесій подавлення
     */
    async getEwSuppressions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputEwSuppressionSessionsList> {
        const response = await this.getEwSuppressionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку зон корпусу з активними частотами відео та керування для оператора РЕБ
     * Зони корпусу з активними частотами
     */
    async getEwZonesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputEwZonesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/ew/zones`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputEwZonesResponseFromJSON(jsonValue));
    }

    /**
     * Отримання списку зон корпусу з активними частотами відео та керування для оператора РЕБ
     * Зони корпусу з активними частотами
     */
    async getEwZones(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputEwZonesResponse> {
        const response = await this.getEwZonesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання одного FAQ запису
     */
    async getFAQRaw(requestParameters: GetFAQRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputFaq>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getFAQ().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/faq/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputFaqFromJSON(jsonValue));
    }

    /**
     * Отримання одного FAQ запису
     */
    async getFAQ(requestParameters: GetFAQRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputFaq> {
        const response = await this.getFAQRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання усіх FAQ записів
     */
    async getFAQsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputFaq>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/faqs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputFaqFromJSON));
    }

    /**
     * Отримання усіх FAQ записів
     */
    async getFAQs(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputFaq>> {
        const response = await this.getFAQsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Завершені місії
     */
    async getFlyHistoryRaw(requestParameters: GetFlyHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputHistoryEvent>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sort_by'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['order_by'] = requestParameters['orderBy'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['_export'] != null) {
            queryParameters['export'] = requestParameters['_export'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/missions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputHistoryEventFromJSON));
    }

    /**
     * Завершені місії
     */
    async getFlyHistory(requestParameters: GetFlyHistoryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputHistoryEvent>> {
        const response = await this.getFlyHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання даних поточної місії
     * Активна місія
     */
    async getFlyMissionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputMissionData>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/fly/mission`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputMissionDataFromJSON(jsonValue));
    }

    /**
     * Отримання даних поточної місії
     * Активна місія
     */
    async getFlyMission(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputMissionData> {
        const response = await this.getFlyMissionRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання даних поточної сесії (бойового чергування) користувача
     * Активна сесія (бойове чергування)
     */
    async getFlySessionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputSessionData>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/fly/session`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputSessionDataFromJSON(jsonValue));
    }

    /**
     * Отримання даних поточної сесії (бойового чергування) користувача
     * Активна сесія (бойове чергування)
     */
    async getFlySession(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputSessionData | null | undefined > {
        const response = await this.getFlySessionRaw(initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Активні місії зони
     */
    async getFlyZoneChannelDataRaw(requestParameters: GetFlyZoneChannelDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputZoneChannelData>> {
        if (requestParameters['zone'] == null) {
            throw new runtime.RequiredError(
                'zone',
                'Required parameter "zone" was null or undefined when calling getFlyZoneChannelData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/fly/zone-channel-data/{zone}`.replace(`{${"zone"}}`, encodeURIComponent(String(requestParameters['zone']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputZoneChannelDataFromJSON(jsonValue));
    }

    /**
     * Активні місії зони
     */
    async getFlyZoneChannelData(requestParameters: GetFlyZoneChannelDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputZoneChannelData> {
        const response = await this.getFlyZoneChannelDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання доступних зон на сторінці диспетчера польотів
     * Зони
     */
    async getFlyZonesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputZone>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/fly/zones`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputZoneFromJSON));
    }

    /**
     * Отримання доступних зон на сторінці диспетчера польотів
     * Зони
     */
    async getFlyZones(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputZone>> {
        const response = await this.getFlyZonesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Карта орієнтування
     */
    async getGeoJsonMapRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputGeoJson>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/map/deep-state`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputGeoJsonFromJSON(jsonValue));
    }

    /**
     * Карта орієнтування
     */
    async getGeoJsonMap(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputGeoJson> {
        const response = await this.getGeoJsonMapRaw(initOverrides);
        return await response.value();
    }

    /**
     * Точка перевірки доступності API для відстеження працездатності застосунку
     * Перевірка доступності застосунку
     */
    async getHealthCheckRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/healthz`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Точка перевірки доступності API для відстеження працездатності застосунку
     * Перевірка доступності застосунку
     */
    async getHealthCheck(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getHealthCheckRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання історії подій
     * Отримання даних для редагування події
     */
    async getHistoryEventDataDataRaw(requestParameters: GetHistoryEventDataDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputHistoryEventEditableData>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getHistoryEventDataData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/history-events/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputHistoryEventEditableDataFromJSON(jsonValue));
    }

    /**
     * Отримання історії подій
     * Отримання даних для редагування події
     */
    async getHistoryEventDataData(requestParameters: GetHistoryEventDataDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputHistoryEventEditableData> {
        const response = await this.getHistoryEventDataDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання даних по відправкам в дельту
     * Отримання даних по відправкам в дельту
     */
    async getHistoryEventsDeltaLogRaw(requestParameters: GetHistoryEventsDeltaLogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputDeltaLogData>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getHistoryEventsDeltaLog().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/history-events/{id}/delta`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputDeltaLogDataFromJSON));
    }

    /**
     * Отримання даних по відправкам в дельту
     * Отримання даних по відправкам в дельту
     */
    async getHistoryEventsDeltaLog(requestParameters: GetHistoryEventsDeltaLogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputDeltaLogData>> {
        const response = await this.getHistoryEventsDeltaLogRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Канали для autocomplete-елементу в фільтрах
     */
    async getMissionChannelsForFilterRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputFiltersSelectStringItem>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/filters/mission-channels`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputFiltersSelectStringItemFromJSON));
    }

    /**
     * Канали для autocomplete-елементу в фільтрах
     */
    async getMissionChannelsForFilter(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputFiltersSelectStringItem>> {
        const response = await this.getMissionChannelsForFilterRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання даних по відправкам в дельту
     * Отримання даних по відправкам в дельту
     */
    async getMissionDeltaLogRaw(requestParameters: GetMissionDeltaLogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputDeltaLogData>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMissionDeltaLog().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/missions/{id}/delta`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputDeltaLogDataFromJSON));
    }

    /**
     * Отримання даних по відправкам в дельту
     * Отримання даних по відправкам в дельту
     */
    async getMissionDeltaLog(requestParameters: GetMissionDeltaLogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputDeltaLogData>> {
        const response = await this.getMissionDeltaLogRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання історії завершених місій
     * Отримання даних для редагування місії
     */
    async getMissionEditableDataRaw(requestParameters: GetMissionEditableDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputHistoryEditableData>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMissionEditableData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/missions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputHistoryEditableDataFromJSON(jsonValue));
    }

    /**
     * Отримання історії завершених місій
     * Отримання даних для редагування місії
     */
    async getMissionEditableData(requestParameters: GetMissionEditableDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputHistoryEditableData> {
        const response = await this.getMissionEditableDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Теги місій для autocomplete-елементу в фільтрах
     */
    async getMissionTagsForFilterRaw(requestParameters: GetMissionTagsForFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/filters/mission-tags`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Теги місій для autocomplete-елементу в фільтрах
     */
    async getMissionTagsForFilter(requestParameters: GetMissionTagsForFilterRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getMissionTagsForFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Типи цілей для autocomplete-елементу в фільтрах
     */
    async getMissionTargetTypesForFilterRaw(requestParameters: GetMissionTargetTypesForFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/filters/mission-target-types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Типи цілей для autocomplete-елементу в фільтрах
     */
    async getMissionTargetTypesForFilter(requestParameters: GetMissionTargetTypesForFilterRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getMissionTargetTypesForFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання новин в залежності від ролі
     */
    async getNewsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputNews>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/news`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputNewsFromJSON));
    }

    /**
     * Отримання новин в залежності від ролі
     */
    async getNews(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputNews>> {
        const response = await this.getNewsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання новини за ID
     */
    async getNewsItemRaw(requestParameters: GetNewsItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputNews>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getNewsItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/news/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputNewsFromJSON(jsonValue));
    }

    /**
     * Отримання новини за ID
     */
    async getNewsItem(requestParameters: GetNewsItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputNews> {
        const response = await this.getNewsItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Список сповіщень користувача
     * Сповіщення
     */
    async getNotificationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputNotification>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/notifications`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputNotificationFromJSON));
    }

    /**
     * Список сповіщень користувача
     * Сповіщення
     */
    async getNotifications(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputNotification>> {
        const response = await this.getNotificationsRaw(initOverrides);
        return await response.value();
    }

    /**
     * ОСУВ для autocomplete-елементу в фільтрах
     */
    async getOsgsForFilterRaw(requestParameters: GetOsgsForFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputFiltersSelectItem>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/filters/osgs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputFiltersSelectItemFromJSON));
    }

    /**
     * ОСУВ для autocomplete-елементу в фільтрах
     */
    async getOsgsForFilter(requestParameters: GetOsgsForFilterRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputFiltersSelectItem>> {
        const response = await this.getOsgsForFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Корпуси для autocomplete-елементу в фільтрах
     */
    async getOtgsForFilterRaw(requestParameters: GetOtgsForFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputFiltersSelectItem>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/filters/otgs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputFiltersSelectItemFromJSON));
    }

    /**
     * Корпуси для autocomplete-елементу в фільтрах
     */
    async getOtgsForFilter(requestParameters: GetOtgsForFilterRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputFiltersSelectItem>> {
        const response = await this.getOtgsForFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання налаштувань екіпажу
     */
    async getPilotTeamSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputPilotTeamSettings>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/pilot/team-settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputPilotTeamSettingsFromJSON(jsonValue));
    }

    /**
     * Отримання налаштувань екіпажу
     */
    async getPilotTeamSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputPilotTeamSettings> {
        const response = await this.getPilotTeamSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання використаних каналів команди
     */
    async getPilotTeamUsedChannelsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputTeamUsedChannels>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/pilot/team-used-channels`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputTeamUsedChannelsFromJSON(jsonValue));
    }

    /**
     * Отримання використаних каналів команди
     */
    async getPilotTeamUsedChannels(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputTeamUsedChannels> {
        const response = await this.getPilotTeamUsedChannelsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку відео-посилань для екіпажу поточного пілота
     * Відео-посилання екіпажу пілота
     */
    async getPilotTeamVideoLinksRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputOutputTeamVideoLink>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/pilot/team-video-links`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputOutputTeamVideoLinkFromJSON));
    }

    /**
     * Отримання списку відео-посилань для екіпажу поточного пілота
     * Відео-посилання екіпажу пілота
     */
    async getPilotTeamVideoLinks(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputOutputTeamVideoLink>> {
        const response = await this.getPilotTeamVideoLinksRaw(initOverrides);
        return await response.value();
    }

    /**
     * Пілоти для autocomplete-елементу в фільтрах
     */
    async getPilotsForFilterRaw(requestParameters: GetPilotsForFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputFiltersSelectItem>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/filters/pilots`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputFiltersSelectItemFromJSON));
    }

    /**
     * Пілоти для autocomplete-елементу в фільтрах
     */
    async getPilotsForFilter(requestParameters: GetPilotsForFilterRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputFiltersSelectItem>> {
        const response = await this.getPilotsForFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання інформації про позицію з перевіркою доступу через ACL
     * Отримання позиції
     */
    async getPositionRaw(requestParameters: GetPositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputPosition>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPosition().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/positions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputPositionFromJSON(jsonValue));
    }

    /**
     * Отримання інформації про позицію з перевіркою доступу через ACL
     * Отримання позиції
     */
    async getPosition(requestParameters: GetPositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputPosition> {
        const response = await this.getPositionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання детальної статистики витрат дронів та боєкомплектів за різні періоди
     * Отримання статистики витрат засобів на позиції
     */
    async getPositionStockStatisticsRaw(requestParameters: GetPositionStockStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputPositionStockStatistics>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPositionStockStatistics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/positions/{id}/stock-statistics`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputPositionStockStatisticsFromJSON(jsonValue));
    }

    /**
     * Отримання детальної статистики витрат дронів та боєкомплектів за різні періоди
     * Отримання статистики витрат засобів на позиції
     */
    async getPositionStockStatistics(requestParameters: GetPositionStockStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputPositionStockStatistics> {
        const response = await this.getPositionStockStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку позицій з фільтрацією, пагінацією та сортуванням. Фільтрація через ACL забезпечує доступ лише до дозволених підрозділів.
     * Отримання списку позицій
     */
    async getPositionsRaw(requestParameters: GetPositionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputPosition>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sort_by'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['order_by'] = requestParameters['orderBy'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['isHub'] != null) {
            queryParameters['isHub'] = requestParameters['isHub'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/positions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputPositionFromJSON));
    }

    /**
     * Отримання списку позицій з фільтрацією, пагінацією та сортуванням. Фільтрація через ACL забезпечує доступ лише до дозволених підрозділів.
     * Отримання списку позицій
     */
    async getPositions(requestParameters: GetPositionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputPosition>> {
        const response = await this.getPositionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання статистики ReadStore кешів
     */
    async getReadStoreStatsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputReadStoreStats>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/system/read-stores`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputReadStoreStatsFromJSON));
    }

    /**
     * Отримання статистики ReadStore кешів
     */
    async getReadStoreStats(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputReadStoreStats>> {
        const response = await this.getReadStoreStatsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання сесій БЧ ( RESTFul модель)
     */
    async getSessionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputSession>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/sessions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputSessionFromJSON));
    }

    /**
     * Отримання сесій БЧ ( RESTFul модель)
     */
    async getSessions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputSession>> {
        const response = await this.getSessionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку екіпажів з додатковою інформацією про попередні та активні політні сесії
     * Отримання екіпажів для сесій
     */
    async getSessionsDataRaw(requestParameters: GetSessionsDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputSessionsData>> {
        const queryParameters: any = {};

        if (requestParameters['division'] != null) {
            queryParameters['division'] = requestParameters['division'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/sessions/data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputSessionsDataFromJSON(jsonValue));
    }

    /**
     * Отримання списку екіпажів з додатковою інформацією про попередні та активні політні сесії
     * Отримання екіпажів для сесій
     */
    async getSessionsData(requestParameters: GetSessionsDataRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputSessionsData> {
        const response = await this.getSessionsDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку пілотів, які можуть бути назначені в інтерфейсі затвердження політних сесій
     * Отримання пілотів
     */
    async getSessionsPilotsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/sessions/pilots`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Отримання списку пілотів, які можуть бути назначені в інтерфейсі затвердження політних сесій
     * Отримання пілотів
     */
    async getSessionsPilots(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getSessionsPilotsRaw(initOverrides);
    }

    /**
     * Отримання списку акаунтів signal
     * Отримання списку акаунтів signal
     */
    async getSignalAccountsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/signal/accounts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Отримання списку акаунтів signal
     * Отримання списку акаунтів signal
     */
    async getSignalAccounts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getSignalAccountsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання груп головного акаунту signal
     * Отримання груп головного акаунту signal
     */
    async getSignalGroupsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputSignalGroup>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/signal/groups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputSignalGroupFromJSON));
    }

    /**
     * Отримання груп головного акаунту signal
     * Отримання груп головного акаунту signal
     */
    async getSignalGroups(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputSignalGroup>> {
        const response = await this.getSignalGroupsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання логу cтатусів інтеграції з signal
     * Отримання логу cтатусів інтеграції з signal
     */
    async getSignalIntegrationLogRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputSignalIntegrationLogItem>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/signal/log`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputSignalIntegrationLogItemFromJSON));
    }

    /**
     * Отримання логу cтатусів інтеграції з signal
     * Отримання логу cтатусів інтеграції з signal
     */
    async getSignalIntegrationLog(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputSignalIntegrationLogItem>> {
        const response = await this.getSignalIntegrationLogRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання cтатусу інтеграції з signal
     * Отримання cтатусу інтеграції з signal
     */
    async getSignalIntegrationStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputSignalIntegrationStatus>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/signal/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputSignalIntegrationStatusFromJSON(jsonValue));
    }

    /**
     * Отримання cтатусу інтеграції з signal
     * Отримання cтатусу інтеграції з signal
     */
    async getSignalIntegrationStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputSignalIntegrationStatus> {
        const response = await this.getSignalIntegrationStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання телефону для signal
     * Отримання телефону для signal
     */
    async getSignalPhoneRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/signal/phone`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Отримання телефону для signal
     * Отримання телефону для signal
     */
    async getSignalPhone(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getSignalPhoneRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання QR коду для інтеграції signal
     * Отримання QR коду для інтеграції signal
     */
    async getSignalQRCodeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/signal/qr`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Отримання QR коду для інтеграції signal
     * Отримання QR коду для інтеграції signal
     */
    async getSignalQRCode(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getSignalQRCodeRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку засобів (дрони/боєкомплекти) - read-only для всіх ролей
     * Отримання списку засобів
     */
    async getStockItemsRaw(requestParameters: GetStockItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputStockItem>>> {
        const queryParameters: any = {};

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/stock-items`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputStockItemFromJSON));
    }

    /**
     * Отримання списку засобів (дрони/боєкомплекти) - read-only для всіх ролей
     * Отримання списку засобів
     */
    async getStockItems(requestParameters: GetStockItemsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputStockItem>> {
        const response = await this.getStockItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання привілей системи
     */
    async getSystemPermissionsRaw(requestParameters: GetSystemPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputSystemPermission>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sort_by'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['order_by'] = requestParameters['orderBy'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/system/permissions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputSystemPermissionFromJSON));
    }

    /**
     * Отримання привілей системи
     */
    async getSystemPermissions(requestParameters: GetSystemPermissionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputSystemPermission>> {
        const response = await this.getSystemPermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання даних для редагування цілі
     */
    async getTargetDataRaw(requestParameters: GetTargetDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputTargetData>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTargetData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/targets/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputTargetDataFromJSON(jsonValue));
    }

    /**
     * Отримання даних для редагування цілі
     */
    async getTargetData(requestParameters: GetTargetDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputTargetData> {
        const response = await this.getTargetDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку цілей підрозділу в інтерфейсі історії
     * Отримання списку цілей для місії
     */
    async getTargetListForMissionRaw(requestParameters: GetTargetListForMissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputTargetSelectData>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTargetListForMission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/missions/{id}/targets`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputTargetSelectDataFromJSON));
    }

    /**
     * Отримання списку цілей підрозділу в інтерфейсі історії
     * Отримання списку цілей для місії
     */
    async getTargetListForMission(requestParameters: GetTargetListForMissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputTargetSelectData>> {
        const response = await this.getTargetListForMissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання типів цілей
     */
    async getTargetTypesListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputTargetTypesResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/target-types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputTargetTypesResultFromJSON(jsonValue));
    }

    /**
     * Отримання типів цілей
     */
    async getTargetTypesList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputTargetTypesResult> {
        const response = await this.getTargetTypesListRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку цілей підрозділу
     * Отримання списку цілей підрозділу
     */
    async getTargetsForDivisionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputTargetWithZoneSelectData>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/history-events/targets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputTargetWithZoneSelectDataFromJSON));
    }

    /**
     * Отримання списку цілей підрозділу
     * Отримання списку цілей підрозділу
     */
    async getTargetsForDivision(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputTargetWithZoneSelectData>> {
        const response = await this.getTargetsForDivisionRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку цілей підрозділу
     */
    async getTargetsListRaw(requestParameters: GetTargetsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputTargetsResult>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sort_by'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['order_by'] = requestParameters['orderBy'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/targets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputTargetsResultFromJSON(jsonValue));
    }

    /**
     * Отримання списку цілей підрозділу
     */
    async getTargetsList(requestParameters: GetTargetsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputTargetsResult> {
        const response = await this.getTargetsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку екіпажів підрозділу
     * Отримання списку екіпажів підрозділу
     */
    async getTeamsForDivisionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputTeamShort>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/history-events/teams`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputTeamShortFromJSON));
    }

    /**
     * Отримання списку екіпажів підрозділу
     * Отримання списку екіпажів підрозділу
     */
    async getTeamsForDivision(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputTeamShort>> {
        const response = await this.getTeamsForDivisionRaw(initOverrides);
        return await response.value();
    }

    /**
     * Екіпажі для autocomplete-елементу в фільтрах
     */
    async getTeamsForFilterRaw(requestParameters: GetTeamsForFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputFiltersSelectItem>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/filters/teams`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputFiltersSelectItemFromJSON));
    }

    /**
     * Екіпажі для autocomplete-елементу в фільтрах
     */
    async getTeamsForFilter(requestParameters: GetTeamsForFilterRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputFiltersSelectItem>> {
        const response = await this.getTeamsForFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Повертає інформацію про налаштування 2FA користувача
     * Отримання статусу 2FA
     */
    async getTwoFactorStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputTwoFactorStatusResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/two-factor/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputTwoFactorStatusResponseFromJSON(jsonValue));
    }

    /**
     * Повертає інформацію про налаштування 2FA користувача
     * Отримання статусу 2FA
     */
    async getTwoFactorStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputTwoFactorStatusResponse> {
        const response = await this.getTwoFactorStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * Свій екіпаж, його склад і сталі параметри вильоту — усе, чим сторінка вильоту заповнює форму. Порожній teamId означає, що користувача ще не додали до складу або екіпаж не активовано.
     * Контекст екіпажу БпЛА
     */
    async getUavCrewContextRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputUavCrewContext>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/uav-crew/context`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputUavCrewContextFromJSON(jsonValue));
    }

    /**
     * Свій екіпаж, його склад і сталі параметри вильоту — усе, чим сторінка вильоту заповнює форму. Порожній teamId означає, що користувача ще не додали до складу або екіпаж не активовано.
     * Контекст екіпажу БпЛА
     */
    async getUavCrewContext(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputUavCrewContext> {
        const response = await this.getUavCrewContextRaw(initOverrides);
        return await response.value();
    }

    /**
     * Довідник uav_crews для фільтрів диспетчерської/історії (read-only). Subtitle — підрозділ екіпажу
     * Екіпажі БпЛА (позивні) для autocomplete-елементу
     */
    async getUavCrewsForFilterRaw(requestParameters: GetUavCrewsForFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputFiltersSelectItem>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/filters/uav-crews`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputFiltersSelectItemFromJSON));
    }

    /**
     * Довідник uav_crews для фільтрів диспетчерської/історії (read-only). Subtitle — підрозділ екіпажу
     * Екіпажі БпЛА (позивні) для autocomplete-елементу
     */
    async getUavCrewsForFilter(requestParameters: GetUavCrewsForFilterRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputFiltersSelectItem>> {
        const response = await this.getUavCrewsForFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання інформації про заявку на політ борта
     * Отримання uav-місії
     */
    async getUavMissionRaw(requestParameters: GetUavMissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputUavMission>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getUavMission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/uav-missions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputUavMissionFromJSON(jsonValue));
    }

    /**
     * Отримання інформації про заявку на політ борта
     * Отримання uav-місії
     */
    async getUavMission(requestParameters: GetUavMissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputUavMission> {
        const response = await this.getUavMissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Список унікальних кімнат-джерел заявок uav_missions. Назва береться зі збереженої (свіжішої) назви кімнати з Matrix; якщо порожня — показуємо сирий room id.
     * Чати (Matrix-кімнати) для autocomplete-елементу в фільтрах
     */
    async getUavMissionChatsForFilterRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputFiltersSelectStringItem>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/filters/uav-mission-chats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputFiltersSelectStringItemFromJSON));
    }

    /**
     * Список унікальних кімнат-джерел заявок uav_missions. Назва береться зі збереженої (свіжішої) назви кімнати з Matrix; якщо порожня — показуємо сирий room id.
     * Чати (Matrix-кімнати) для autocomplete-елементу в фільтрах
     */
    async getUavMissionChatsForFilter(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputFiltersSelectStringItem>> {
        const response = await this.getUavMissionChatsForFilterRaw(initOverrides);
        return await response.value();
    }

    /**
     * Тред нотаток чергового по заявці на політ борта (хронологічно)
     * Нотатки чергового по місії
     */
    async getUavMissionNotesRaw(requestParameters: GetUavMissionNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputUavMissionNote>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getUavMissionNotes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/uav-missions/{id}/notes`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputUavMissionNoteFromJSON));
    }

    /**
     * Тред нотаток чергового по заявці на політ борта (хронологічно)
     * Нотатки чергового по місії
     */
    async getUavMissionNotes(requestParameters: GetUavMissionNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputUavMissionNote>> {
        const response = await this.getUavMissionNotesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Журнал переходів між фазами (append-only, хронологічно): коли борт підняли, коли перейшов за ЛБЗ, коли сів. З нього складається підсумок завершеного вильоту.
     * Хронологія фаз польоту
     */
    async getUavMissionStatusEventsRaw(requestParameters: GetUavMissionStatusEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputUavMissionStatusEvent>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getUavMissionStatusEvents().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/uav-missions/{id}/status-events`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputUavMissionStatusEventFromJSON));
    }

    /**
     * Журнал переходів між фазами (append-only, хронологічно): коли борт підняли, коли перейшов за ЛБЗ, коли сів. З нього складається підсумок завершеного вильоту.
     * Хронологія фаз польоту
     */
    async getUavMissionStatusEvents(requestParameters: GetUavMissionStatusEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputUavMissionStatusEvent>> {
        const response = await this.getUavMissionStatusEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Збережені заготовки заявок, видимі в межах підрозділу автора
     * Шаблони заявок на політ борта
     */
    async getUavMissionTemplatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputUavMissionTemplate>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/uav-mission-templates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputUavMissionTemplateFromJSON));
    }

    /**
     * Збережені заготовки заявок, видимі в межах підрозділу автора
     * Шаблони заявок на політ борта
     */
    async getUavMissionTemplates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputUavMissionTemplate>> {
        const response = await this.getUavMissionTemplatesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Список заявок на політ бортів з фільтрацією, пагінацією та сортуванням. mode=active — усі незавершені заявки та щойно завершені в межах резервного часу, mode=upcoming — заплановані на майбутні дати, mode=history — завершені заявки після резервного часу
     * Список uav-місій
     */
    async getUavMissionsRaw(requestParameters: GetUavMissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputUavMission>>> {
        const queryParameters: any = {};

        if (requestParameters['mode'] != null) {
            queryParameters['mode'] = requestParameters['mode'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sort_by'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['order_by'] = requestParameters['orderBy'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/uav-missions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputUavMissionFromJSON));
    }

    /**
     * Список заявок на політ бортів з фільтрацією, пагінацією та сортуванням. mode=active — усі незавершені заявки та щойно завершені в межах резервного часу, mode=upcoming — заплановані на майбутні дати, mode=history — завершені заявки після резервного часу
     * Список uav-місій
     */
    async getUavMissions(requestParameters: GetUavMissionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputUavMission>> {
        const response = await this.getUavMissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Засоби з ТТХ (тип, швидкість, частоти, ресурс) для форми подачі заявки. Read-only; редагування довідника — в адмінці
     * Довідник засобів БпЛА з ТТХ
     */
    async getUavPlatformsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputUavPlatform>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/uav-platforms`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputUavPlatformFromJSON));
    }

    /**
     * Засоби з ТТХ (тип, швидкість, частоти, ресурс) для форми подачі заявки. Read-only; редагування довідника — в адмінці
     * Довідник засобів БпЛА з ТТХ
     */
    async getUavPlatforms(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputUavPlatform>> {
        const response = await this.getUavPlatformsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Довідник uav_platforms для вибору борта у формах (read-only)
     * Борти БпЛА для autocomplete-елементу
     */
    async getUavPlatformsForFilterRaw(requestParameters: GetUavPlatformsForFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputFiltersSelectItem>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/filters/uav-platforms`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputFiltersSelectItemFromJSON));
    }

    /**
     * Довідник uav_platforms для вибору борта у формах (read-only)
     * Борти БпЛА для autocomplete-елементу
     */
    async getUavPlatformsForFilter(requestParameters: GetUavPlatformsForFilterRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputFiltersSelectItem>> {
        const response = await this.getUavPlatformsForFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Довідник uav_units для фільтрів диспетчерської/історії (read-only)
     * Підрозділи БпЛА для autocomplete-елементу
     */
    async getUavUnitsForFilterRaw(requestParameters: GetUavUnitsForFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputFiltersSelectItem>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/filters/uav-units`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputFiltersSelectItemFromJSON));
    }

    /**
     * Довідник uav_units для фільтрів диспетчерської/історії (read-only)
     * Підрозділи БпЛА для autocomplete-елементу
     */
    async getUavUnitsForFilter(requestParameters: GetUavUnitsForFilterRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputFiltersSelectItem>> {
        const response = await this.getUavUnitsForFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання профілю користувача
     */
    async getUserProfileRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputUserProfile>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/users/profile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputUserProfileFromJSON(jsonValue));
    }

    /**
     * Отримання профілю користувача
     */
    async getUserProfile(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputUserProfile> {
        const response = await this.getUserProfileRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання останніх політних даних, таких як пілот, смуга, канал, для передзаповнення форми
     * Остані політні дані для передзаповнення форми
     */
    async getUsersLastFlightDataRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputLastFlightData>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/fly/last-mission-data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputLastFlightDataFromJSON(jsonValue));
    }

    /**
     * Отримання останніх політних даних, таких як пілот, смуга, канал, для передзаповнення форми
     * Остані політні дані для передзаповнення форми
     */
    async getUsersLastFlightData(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputLastFlightData> {
        const response = await this.getUsersLastFlightDataRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання прапорців статуса навчання для командир
     * Статус навчання
     */
    async getWalkthroughStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputWalkthroughStatus>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/walkthrough/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputWalkthroughStatusFromJSON(jsonValue));
    }

    /**
     * Отримання прапорців статуса навчання для командир
     * Статус навчання
     */
    async getWalkthroughStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputWalkthroughStatus> {
        const response = await this.getWalkthroughStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * Параметри сітки, спожита квота Open-Meteo, історія прогонів воркера та якість даних.
     * Стан збору даних вітру (Open-Meteo)
     */
    async getWeatherStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputWeatherStatus>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/system/weather`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputWeatherStatusFromJSON(jsonValue));
    }

    /**
     * Параметри сітки, спожита квота Open-Meteo, історія прогонів воркера та якість даних.
     * Стан збору даних вітру (Open-Meteo)
     */
    async getWeatherStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputWeatherStatus> {
        const response = await this.getWeatherStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * Вітер (складові u/v, м/с) по вузлах сітки збору на обраній висоті, найсвіжіший часовий зріз. Опційний bbox (minLat,minLng,maxLat,maxLng) для видимої області.
     * Шар вітру над ЛБЗ
     */
    async getWindMapRaw(requestParameters: GetWindMapRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RepositoriesWindMapPoint>>> {
        const queryParameters: any = {};

        if (requestParameters['altitude'] != null) {
            queryParameters['altitude'] = requestParameters['altitude'];
        }

        if (requestParameters['minLat'] != null) {
            queryParameters['minLat'] = requestParameters['minLat'];
        }

        if (requestParameters['minLng'] != null) {
            queryParameters['minLng'] = requestParameters['minLng'];
        }

        if (requestParameters['maxLat'] != null) {
            queryParameters['maxLat'] = requestParameters['maxLat'];
        }

        if (requestParameters['maxLng'] != null) {
            queryParameters['maxLng'] = requestParameters['maxLng'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/map/wind`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RepositoriesWindMapPointFromJSON));
    }

    /**
     * Вітер (складові u/v, м/с) по вузлах сітки збору на обраній висоті, найсвіжіший часовий зріз. Опційний bbox (minLat,minLng,maxLat,maxLng) для видимої області.
     * Шар вітру над ЛБЗ
     */
    async getWindMap(requestParameters: GetWindMapRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RepositoriesWindMapPoint>> {
        const response = await this.getWindMapRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Регулярна сітка u/v на обраній висоті у форматі leaflet-velocity (2 записи: U, V).
     * Поле вітру для анімації (leaflet-velocity)
     */
    async getWindVelocityRaw(requestParameters: GetWindVelocityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HandlersWindVelocityRecord>>> {
        const queryParameters: any = {};

        if (requestParameters['altitude'] != null) {
            queryParameters['altitude'] = requestParameters['altitude'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/map/wind/velocity`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HandlersWindVelocityRecordFromJSON));
    }

    /**
     * Регулярна сітка u/v на обраній висоті у форматі leaflet-velocity (2 записи: U, V).
     * Поле вітру для анімації (leaflet-velocity)
     */
    async getWindVelocity(requestParameters: GetWindVelocityRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<HandlersWindVelocityRecord>> {
        const response = await this.getWindVelocityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку повідомлень
     * Список повідомлень
     */
    async getZoneAdminBroadcastNotificationsListRaw(requestParameters: GetZoneAdminBroadcastNotificationsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputZoneAdminBroadcastMessage>>> {
        const queryParameters: any = {};

        if (requestParameters['sortBy'] != null) {
            queryParameters['sort_by'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['order_by'] = requestParameters['orderBy'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/zone-admin/broadcast`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputZoneAdminBroadcastMessageFromJSON));
    }

    /**
     * Отримання списку повідомлень
     * Список повідомлень
     */
    async getZoneAdminBroadcastNotificationsList(requestParameters: GetZoneAdminBroadcastNotificationsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputZoneAdminBroadcastMessage>> {
        const response = await this.getZoneAdminBroadcastNotificationsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання всіх підрозділів для координатора зони
     * Список підрозділів
     */
    async getZoneAdminDivisionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputZoneAdminDivision>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/zone-admin/divisions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputZoneAdminDivisionFromJSON));
    }

    /**
     * Отримання всіх підрозділів для координатора зони
     * Список підрозділів
     */
    async getZoneAdminDivisions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputZoneAdminDivision>> {
        const response = await this.getZoneAdminDivisionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку зон для координатора корпусу
     */
    async getZoneAdminOtgZonesListRaw(requestParameters: GetZoneAdminOtgZonesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputZoneRequestsZonesSelector>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getZoneAdminOtgZonesList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/zone-admin/zones-list/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputZoneRequestsZonesSelectorFromJSON));
    }

    /**
     * Отримання списку зон для координатора корпусу
     */
    async getZoneAdminOtgZonesList(requestParameters: GetZoneAdminOtgZonesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputZoneRequestsZonesSelector>> {
        const response = await this.getZoneAdminOtgZonesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання інформації про заявку в інтерфейсі координатора зони
     * Отримання інформації про заявки
     */
    async getZoneAdminRequestRaw(requestParameters: GetZoneAdminRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputZoneAdminRequest>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getZoneAdminRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/zone-admin/requests/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputZoneAdminRequestFromJSON(jsonValue));
    }

    /**
     * Отримання інформації про заявку в інтерфейсі координатора зони
     * Отримання інформації про заявки
     */
    async getZoneAdminRequest(requestParameters: GetZoneAdminRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputZoneAdminRequest> {
        const response = await this.getZoneAdminRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку активних заявок на доєднання до зони
     * Список заявок на доєднання до зони
     */
    async getZoneAdminRequestsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputZoneAdminRequest>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/zone-admin/requests`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputZoneAdminRequestFromJSON));
    }

    /**
     * Отримання списку активних заявок на доєднання до зони
     * Список заявок на доєднання до зони
     */
    async getZoneAdminRequests(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputZoneAdminRequest>> {
        const response = await this.getZoneAdminRequestsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Керування запитами на приєднання до зони (командир)
     */
    async getZoneRequestsListRaw(requestParameters: GetZoneRequestsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputZoneRequestsResult>> {
        const queryParameters: any = {};

        if (requestParameters['sortBy'] != null) {
            queryParameters['sort_by'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['order_by'] = requestParameters['orderBy'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/division/zone-requests`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputZoneRequestsResultFromJSON(jsonValue));
    }

    /**
     * Керування запитами на приєднання до зони (командир)
     */
    async getZoneRequestsList(requestParameters: GetZoneRequestsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputZoneRequestsResult> {
        const response = await this.getZoneRequestsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку зон для форми запита
     */
    async getZoneRequestsOtgListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputZoneRequestsOtgsSelector>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/division/zone-requests/otg-list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputZoneRequestsOtgsSelectorFromJSON));
    }

    /**
     * Отримання списку зон для форми запита
     */
    async getZoneRequestsOtgList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputZoneRequestsOtgsSelector>> {
        const response = await this.getZoneRequestsOtgListRaw(initOverrides);
        return await response.value();
    }

    /**
     * Отримання списку зон підрозділу
     * Отримання списку зон підрозділу
     */
    async getZonesForDivisionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputZoneShort>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/history-events/zones`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputZoneShortFromJSON));
    }

    /**
     * Отримання списку зон підрозділу
     * Отримання списку зон підрозділу
     */
    async getZonesForDivision(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputZoneShort>> {
        const response = await this.getZonesForDivisionRaw(initOverrides);
        return await response.value();
    }

    /**
     * Зони для autocomplete-елементу в фільтрах
     */
    async getZonesForFilterRaw(requestParameters: GetZonesForFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputFiltersSelectItem>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/filters/zones`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputFiltersSelectItemFromJSON));
    }

    /**
     * Зони для autocomplete-елементу в фільтрах
     */
    async getZonesForFilter(requestParameters: GetZonesForFilterRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputFiltersSelectItem>> {
        const response = await this.getZonesForFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримання координат зон
     */
    async getZonesMapDataRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputMapZoneDataItem>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/map/zones-data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputMapZoneDataItemFromJSON));
    }

    /**
     * Отримання координат зон
     */
    async getZonesMapData(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputMapZoneDataItem>> {
        const response = await this.getZonesMapDataRaw(initOverrides);
        return await response.value();
    }

    /**
     * Зони для динамічного відображення craftName та DroneUid в формі екіпажів
     */
    async getZonesWithDambaIntegrationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/teams/zones-with-damba-integration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Зони для динамічного відображення craftName та DroneUid в формі екіпажів
     */
    async getZonesWithDambaIntegration(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.getZonesWithDambaIntegrationRaw(initOverrides);
        return await response.value();
    }

    /**
     * Завершення робочої сесії, з подальшим видаленням токен-куки доступу
     * Вихід з системи
     */
    async logoutAuthRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/auth/logout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Завершення робочої сесії, з подальшим видаленням токен-куки доступу
     * Вихід з системи
     */
    async logoutAuth(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.logoutAuthRaw(initOverrides);
        return await response.value();
    }

    /**
     * Додання або редагування права
     */
    async manageSystemPermissionRaw(requestParameters: ManageSystemPermissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['name'] == null) {
            throw new runtime.RequiredError(
                'name',
                'Required parameter "name" was null or undefined when calling manageSystemPermission().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling manageSystemPermission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/system/permission/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters['name']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputSystemPermissionToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Додання або редагування права
     */
    async manageSystemPermission(requestParameters: ManageSystemPermissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.manageSystemPermissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Позначити сповіщення як прочитане
     * Зміна статуса сповіщення
     */
    async markNotificationReadRaw(requestParameters: MarkNotificationReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling markNotificationRead().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/notification/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Позначити сповіщення як прочитане
     * Зміна статуса сповіщення
     */
    async markNotificationRead(requestParameters: MarkNotificationReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.markNotificationReadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Запам\'ятовує останню нотатку заявки як прочитану поточним користувачем — маркер непрочитаних гасне і не повертається після перезавантаження сторінки
     * Позначити тред заявки прочитаним
     */
    async markUavMissionNotesReadRaw(requestParameters: MarkUavMissionNotesReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling markUavMissionNotesRead().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/uav-missions/{id}/notes/read`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Запам\'ятовує останню нотатку заявки як прочитану поточним користувачем — маркер непрочитаних гасне і не повертається після перезавантаження сторінки
     * Позначити тред заявки прочитаним
     */
    async markUavMissionNotesRead(requestParameters: MarkUavMissionNotesReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.markUavMissionNotesReadRaw(requestParameters, initOverrides);
    }

    /**
     * Обʼєднання двох дублікатів підрозділів в один
     * Обʼєднання дублікатів підрозділів
     */
    async mergeDivisionsRaw(requestParameters: MergeDivisionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling mergeDivisions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/merger/merge`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputMergeDivisionsToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Обʼєднання двох дублікатів підрозділів в один
     * Обʼєднання дублікатів підрозділів
     */
    async mergeDivisions(requestParameters: MergeDivisionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.mergeDivisionsRaw(requestParameters, initOverrides);
    }

    /**
     * Перевірка токену для пушів
     */
    async notificationCheckPushTokenRaw(requestParameters: NotificationCheckPushTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling notificationCheckPushToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/notifications/token/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Перевірка токену для пушів
     */
    async notificationCheckPushToken(requestParameters: NotificationCheckPushTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.notificationCheckPushTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Запис токену для пушів
     */
    async notificationPushTokenRaw(requestParameters: NotificationPushTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling notificationPushToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/notifications/token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputPushTokenToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Запис токену для пушів
     */
    async notificationPushToken(requestParameters: NotificationPushTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.notificationPushTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Сповіщення про новину
     */
    async notifyNewsRaw(requestParameters: NotifyNewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling notifyNews().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/news/{id}/notify`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Сповіщення про новину
     */
    async notifyNews(requestParameters: NotifyNewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.notifyNewsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Отримати presigned URL для S3 та створити файл зі status=pending.
     */
    async presignFileRaw(requestParameters: PresignFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputFilePresign>> {
        if (requestParameters['data'] == null) {
            throw new runtime.RequiredError(
                'data',
                'Required parameter "data" was null or undefined when calling presignFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/files/presign`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputFilePresignToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputFilePresignFromJSON(jsonValue));
    }

    /**
     * Отримати presigned URL для S3 та створити файл зі status=pending.
     */
    async presignFile(requestParameters: PresignFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputFilePresign> {
        const response = await this.presignFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Проганяє сирий текст заявки повним пайплайном (LLM-екстракція, формалізація, геокодинг маршруту) у read-only транзакції та повертає результат разом із розбором рішень геокодера. Нічого не зберігає: заявка не створюється, довідники не поповнюються
     * Тестовий прогін парсингу заявки БпЛА
     */
    async previewUavParseRaw(requestParameters: PreviewUavParseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputUavParsePreview>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling previewUavParse().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/system/uav-parse-preview`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputUavParsePreviewToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputUavParsePreviewFromJSON(jsonValue));
    }

    /**
     * Проганяє сирий текст заявки повним пайплайном (LLM-екстракція, формалізація, геокодинг маршруту) у read-only транзакції та повертає результат разом із розбором рішень геокодера. Нічого не зберігає: заявка не створюється, довідники не поповнюються
     * Тестовий прогін парсингу заявки БпЛА
     */
    async previewUavParse(requestParameters: PreviewUavParseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputUavParsePreview> {
        const response = await this.previewUavParseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Збереження параметрів девайса користувача
     */
    async putBrowserInfoRaw(requestParameters: PutBrowserInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling putBrowserInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/analytics/browser-info`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputBrowsersInfoToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Збереження параметрів девайса користувача
     */
    async putBrowserInfo(requestParameters: PutBrowserInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.putBrowserInfoRaw(requestParameters, initOverrides);
    }

    /**
     * Оновлення одного ReadStore кешу
     */
    async refreshSingleReadStoreRaw(requestParameters: RefreshSingleReadStoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['name'] == null) {
            throw new runtime.RequiredError(
                'name',
                'Required parameter "name" was null or undefined when calling refreshSingleReadStore().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/system/read-stores/{name}/reload`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters['name']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Оновлення одного ReadStore кешу
     */
    async refreshSingleReadStore(requestParameters: RefreshSingleReadStoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.refreshSingleReadStoreRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Додати реакцію в чаті
     */
    async removeChatMessageReactionRaw(requestParameters: RemoveChatMessageReactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['messageId'] == null) {
            throw new runtime.RequiredError(
                'messageId',
                'Required parameter "messageId" was null or undefined when calling removeChatMessageReaction().'
            );
        }

        if (requestParameters['reactionId'] == null) {
            throw new runtime.RequiredError(
                'reactionId',
                'Required parameter "reactionId" was null or undefined when calling removeChatMessageReaction().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/chat/message/{message_id}/reaction/{reaction_id}`.replace(`{${"message_id"}}`, encodeURIComponent(String(requestParameters['messageId']))).replace(`{${"reaction_id"}}`, encodeURIComponent(String(requestParameters['reactionId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Додати реакцію в чаті
     */
    async removeChatMessageReaction(requestParameters: RemoveChatMessageReactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.removeChatMessageReactionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Відключення інтеграції з signal
     * Відключення інтеграції з signal
     */
    async removeSignalIntegrationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/signal`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Відключення інтеграції з signal
     * Відключення інтеграції з signal
     */
    async removeSignalIntegration(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeSignalIntegrationRaw(initOverrides);
    }

    /**
     * Скидання 2FA для користувача (видалення TOTP та WebAuthn). Користувач отримує 24 год доступу без 2FA.
     * Скидання двофакторної автентифікації
     */
    async resetAdminUser2FARaw(requestParameters: ResetAdminUser2FARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling resetAdminUser2FA().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/user/{id}/reset-2fa`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Скидання 2FA для користувача (видалення TOTP та WebAuthn). Користувач отримує 24 год доступу без 2FA.
     * Скидання двофакторної автентифікації
     */
    async resetAdminUser2FA(requestParameters: ResetAdminUser2FARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.resetAdminUser2FARaw(requestParameters, initOverrides);
    }

    /**
     * Перезапуск сесії
     */
    async restartTeamSessionRaw(requestParameters: RestartTeamSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['teamId'] == null) {
            throw new runtime.RequiredError(
                'teamId',
                'Required parameter "teamId" was null or undefined when calling restartTeamSession().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling restartTeamSession().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling restartTeamSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/sessions/restart/team/{team_id}/session_id/{session_id}`.replace(`{${"team_id"}}`, encodeURIComponent(String(requestParameters['teamId']))).replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters['sessionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputRestartTeamSessionToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Перезапуск сесії
     */
    async restartTeamSession(requestParameters: RestartTeamSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.restartTeamSessionRaw(requestParameters, initOverrides);
    }

    /**
     * Зберігає список скидів для bomber місії після її завершення
     * Зберегти скиди бомбер місії
     */
    async saveMissionDropsRaw(requestParameters: SaveMissionDropsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling saveMissionDrops().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling saveMissionDrops().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/missions/{id}/drops`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputSaveMissionDropsToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Зберігає список скидів для bomber місії після її завершення
     * Зберегти скиди бомбер місії
     */
    async saveMissionDrops(requestParameters: SaveMissionDropsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.saveMissionDropsRaw(requestParameters, initOverrides);
    }

    /**
     * Отримання контенту файла
     */
    async serveFileRaw(requestParameters: ServeFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling serveFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/file/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Отримання контенту файла
     */
    async serveFile(requestParameters: ServeFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.serveFileRaw(requestParameters, initOverrides);
    }

    /**
     * Активація відкриває складу екіпажу сторінку подачі заявок і заводить екіпаж у довідник напрямку БпЛА (uav_units/uav_crews), щоб його заявки лягали в диспетчерську як усі інші.
     * Допуск екіпажу БпЛА до роботи
     */
    async setAdminUavTeamActivationRaw(requestParameters: SetAdminUavTeamActivationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling setAdminUavTeamActivation().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling setAdminUavTeamActivation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/team/{id}/uav-activation`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminUavTeamActivationToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Активація відкриває складу екіпажу сторінку подачі заявок і заводить екіпаж у довідник напрямку БпЛА (uav_units/uav_crews), щоб його заявки лягали в диспетчерську як усі інші.
     * Допуск екіпажу БпЛА до роботи
     */
    async setAdminUavTeamActivation(requestParameters: SetAdminUavTeamActivationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.setAdminUavTeamActivationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Переписує склад екіпажу цілком. Кандидати — користувачі з роллю uav_crew у підрозділі екіпажу; юзер може бути лише в одному екіпажі БпЛА.
     * Формування складу екіпажу БпЛА
     */
    async setAdminUavTeamMembersRaw(requestParameters: SetAdminUavTeamMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutputUavCrewMember>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling setAdminUavTeamMembers().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling setAdminUavTeamMembers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/team/{id}/uav-members`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminTeamMembersToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutputUavCrewMemberFromJSON));
    }

    /**
     * Переписує склад екіпажу цілком. Кандидати — користувачі з роллю uav_crew у підрозділі екіпажу; юзер може бути лише в одному екіпажі БпЛА.
     * Формування складу екіпажу БпЛА
     */
    async setAdminUavTeamMembers(requestParameters: SetAdminUavTeamMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutputUavCrewMember>> {
        const response = await this.setAdminUavTeamMembersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Старт місії для екіпажу поточного користувача
     * Старт місії
     */
    async startFlySessionRaw(requestParameters: StartFlySessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling startFlySession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/fly/mission`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputStartSessionToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Старт місії для екіпажу поточного користувача
     * Старт місії
     */
    async startFlySession(requestParameters: StartFlySessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.startFlySessionRaw(requestParameters, initOverrides);
    }

    /**
     * Дострокове завершення активної сесії подавлення
     * Дострокове завершення сесії подавлення
     */
    async stopEwSuppressionRaw(requestParameters: StopEwSuppressionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling stopEwSuppression().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/ew/suppressions/{id}/stop`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Дострокове завершення активної сесії подавлення
     * Дострокове завершення сесії подавлення
     */
    async stopEwSuppression(requestParameters: StopEwSuppressionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.stopEwSuppressionRaw(requestParameters, initOverrides);
    }

    /**
     * Ручне завершення місії для екіпажу поточного користувача
     * Ручне завершення місії
     */
    async stopFlySessionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/fly/mission`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Ручне завершення місії для екіпажу поточного користувача
     * Ручне завершення місії
     */
    async stopFlySession(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.stopFlySessionRaw(initOverrides);
    }

    /**
     * Розблокування підрозділу в адміністративному інтерфейсі
     * Розблокування підрозділу
     */
    async unblockAdminDivisionRaw(requestParameters: UnblockAdminDivisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling unblockAdminDivision().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/division/{id}/unblock`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Розблокування підрозділу в адміністративному інтерфейсі
     * Розблокування підрозділу
     */
    async unblockAdminDivision(requestParameters: UnblockAdminDivisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unblockAdminDivisionRaw(requestParameters, initOverrides);
    }

    /**
     * Тимчасове зняття блокування. Користувач має 24 год для входу в систему.
     * Розблокування користувача
     */
    async unblockAdminUserRaw(requestParameters: UnblockAdminUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling unblockAdminUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/user/{id}/unblock`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Тимчасове зняття блокування. Користувач має 24 год для входу в систему.
     * Розблокування користувача
     */
    async unblockAdminUser(requestParameters: UnblockAdminUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unblockAdminUserRaw(requestParameters, initOverrides);
    }

    /**
     * Оновлення БК в адміністративному інтерфейсі
     * Оновлення БК
     */
    async updateAdminAmmoRaw(requestParameters: UpdateAdminAmmoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateAdminAmmo().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling updateAdminAmmo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/ammo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminAmmoToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Оновлення БК в адміністративному інтерфейсі
     * Оновлення БК
     */
    async updateAdminAmmo(requestParameters: UpdateAdminAmmoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.updateAdminAmmoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Оновлення бригади в адміністративному інтерфейсі
     * Оновлення бригади
     */
    async updateAdminBrigadeRaw(requestParameters: UpdateAdminBrigadeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateAdminBrigade().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling updateAdminBrigade().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/brigade/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminBrigadeToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Оновлення бригади в адміністративному інтерфейсі
     * Оновлення бригади
     */
    async updateAdminBrigade(requestParameters: UpdateAdminBrigadeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.updateAdminBrigadeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Оновлення чату
     */
    async updateAdminChatChannelRaw(requestParameters: UpdateAdminChatChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateAdminChatChannel().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling updateAdminChatChannel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/chat_channel/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputEditAdminChatChannelToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Оновлення чату
     */
    async updateAdminChatChannel(requestParameters: UpdateAdminChatChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.updateAdminChatChannelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Оновлення підрозділу в адміністративному інтерфейсі
     * Оновлення підрозділу
     */
    async updateAdminDivisionRaw(requestParameters: UpdateAdminDivisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateAdminDivision().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling updateAdminDivision().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/division/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminDivisionToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Оновлення підрозділу в адміністративному інтерфейсі
     * Оновлення підрозділу
     */
    async updateAdminDivision(requestParameters: UpdateAdminDivisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.updateAdminDivisionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Оновлення ОСУВ в адміністративному інтерфейсі
     * Оновлення ОСУВ
     */
    async updateAdminOSGRaw(requestParameters: UpdateAdminOSGRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateAdminOSG().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling updateAdminOSG().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/osg/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminOSGToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Оновлення ОСУВ в адміністративному інтерфейсі
     * Оновлення ОСУВ
     */
    async updateAdminOSG(requestParameters: UpdateAdminOSGRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.updateAdminOSGRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Оновлення корпусу в адміністративному інтерфейсі
     * Оновлення корпусу
     */
    async updateAdminOTGRaw(requestParameters: UpdateAdminOTGRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateAdminOTG().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling updateAdminOTG().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/otg/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminOTGToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Оновлення корпусу в адміністративному інтерфейсі
     * Оновлення корпусу
     */
    async updateAdminOTG(requestParameters: UpdateAdminOTGRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.updateAdminOTGRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Заміна меж корпусу. Полігонів може бути кілька; кільця замикаються сервером, самоперетин і накладання частин відхиляються
     * Збереження полігона корпусу
     */
    async updateAdminOTGPolygonRaw(requestParameters: UpdateAdminOTGPolygonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateAdminOTGPolygon().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling updateAdminOTGPolygon().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/otg/{id}/polygon`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminOTGPolygonToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Заміна меж корпусу. Полігонів може бути кілька; кільця замикаються сервером, самоперетин і накладання частин відхиляються
     * Збереження полігона корпусу
     */
    async updateAdminOTGPolygon(requestParameters: UpdateAdminOTGPolygonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.updateAdminOTGPolygonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Оновлення засобу в адміністративному інтерфейсі
     * Оновлення засобу
     */
    async updateAdminStockItemRaw(requestParameters: UpdateAdminStockItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateAdminStockItem().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling updateAdminStockItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/stock-items/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminStockItemToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Оновлення засобу в адміністративному інтерфейсі
     * Оновлення засобу
     */
    async updateAdminStockItem(requestParameters: UpdateAdminStockItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.updateAdminStockItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Оновлення екіпажу в адміністративному інтерфейсі
     * Оновлення екіпажу
     */
    async updateAdminTeamRaw(requestParameters: UpdateAdminTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateAdminTeam().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling updateAdminTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/team/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminTeamToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Оновлення екіпажу в адміністративному інтерфейсі
     * Оновлення екіпажу
     */
    async updateAdminTeam(requestParameters: UpdateAdminTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.updateAdminTeamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Оновлення БпЛА в адміністративному інтерфейсі
     * Оновлення БпЛА
     */
    async updateAdminUavPlatformRaw(requestParameters: UpdateAdminUavPlatformRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateAdminUavPlatform().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling updateAdminUavPlatform().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/uav-platforms/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminUavPlatformToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Оновлення БпЛА в адміністративному інтерфейсі
     * Оновлення БпЛА
     */
    async updateAdminUavPlatform(requestParameters: UpdateAdminUavPlatformRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.updateAdminUavPlatformRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Той самий набір, що екіпаж редагує сам. Командир задає його початково при формуванні екіпажу.
     * Оновлення сталих параметрів вильоту екіпажу БпЛА
     */
    async updateAdminUavTeamSettingsRaw(requestParameters: UpdateAdminUavTeamSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputUavCrewSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateAdminUavTeamSettings().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling updateAdminUavTeamSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/team/{id}/uav-settings`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputUavCrewSettingsToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputUavCrewSettingsFromJSON(jsonValue));
    }

    /**
     * Той самий набір, що екіпаж редагує сам. Командир задає його початково при формуванні екіпажу.
     * Оновлення сталих параметрів вильоту екіпажу БпЛА
     */
    async updateAdminUavTeamSettings(requestParameters: UpdateAdminUavTeamSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputUavCrewSettings> {
        const response = await this.updateAdminUavTeamSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Оновлення користувача в адміністративному інтерфейсі
     * Оновлення користувача
     */
    async updateAdminUserRaw(requestParameters: UpdateAdminUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateAdminUser().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling updateAdminUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/user/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputEditAdminUserToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Оновлення користувача в адміністративному інтерфейсі
     * Оновлення користувача
     */
    async updateAdminUser(requestParameters: UpdateAdminUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.updateAdminUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Оновлення зони в адміністративному інтерфейсі
     * Оновлення зони
     */
    async updateAdminZoneRaw(requestParameters: UpdateAdminZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateAdminZone().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling updateAdminZone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/zone/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdminZoneToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Оновлення зони в адміністративному інтерфейсі
     * Оновлення зони
     */
    async updateAdminZone(requestParameters: UpdateAdminZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.updateAdminZoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Оновлює статус прочитаності для конкретного каналу.
     */
    async updateChatReadStatusRaw(requestParameters: UpdateChatReadStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling updateChatReadStatus().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling updateChatReadStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/chat/{channel_id}/read`.replace(`{${"channel_id"}}`, encodeURIComponent(String(requestParameters['channelId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: InputChannelMessageReadStatusToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Оновлює статус прочитаності для конкретного каналу.
     */
    async updateChatReadStatus(requestParameters: UpdateChatReadStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateChatReadStatusRaw(requestParameters, initOverrides);
    }

    /**
     * Редагування FAQ запису
     */
    async updateFAQRaw(requestParameters: UpdateFAQRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateFAQ().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling updateFAQ().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/faq/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputFAQToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Редагування FAQ запису
     */
    async updateFAQ(requestParameters: UpdateFAQRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.updateFAQRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Оновлення історичної події
     */
    async updateHistoryEventRaw(requestParameters: UpdateHistoryEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateHistoryEvent().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling updateHistoryEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/history-events/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputUpdateHistoryEventToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Оновлення історичної події
     */
    async updateHistoryEvent(requestParameters: UpdateHistoryEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.updateHistoryEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Оновлення каналів для місії в черзі
     * Оновити канали місії
     */
    async updateMissionChannelsRaw(requestParameters: UpdateMissionChannelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateMissionChannels().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling updateMissionChannels().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/mission/{id}/channels`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputUpdateMissionChannelsToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Оновлення каналів для місії в черзі
     * Оновити канали місії
     */
    async updateMissionChannels(requestParameters: UpdateMissionChannelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateMissionChannelsRaw(requestParameters, initOverrides);
    }

    /**
     * Редагування новини
     */
    async updateNewsRaw(requestParameters: UpdateNewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateNews().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling updateNews().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/news/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputNewsToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Редагування новини
     */
    async updateNews(requestParameters: UpdateNewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.updateNewsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Оновлення налаштувань екіпажу
     */
    async updatePilotTeamSettingsRaw(requestParameters: UpdatePilotTeamSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling updatePilotTeamSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/pilot/team-settings`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputUpdatePilotTeamSettingsToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Оновлення налаштувань екіпажу
     */
    async updatePilotTeamSettings(requestParameters: UpdatePilotTeamSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePilotTeamSettingsRaw(requestParameters, initOverrides);
    }

    /**
     * Оновлення позиції з перевіркою доступу через ACL
     * Оновлення позиції
     */
    async updatePositionRaw(requestParameters: UpdatePositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updatePosition().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling updatePosition().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/positions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputPositionUpdateToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Оновлення позиції з перевіркою доступу через ACL
     * Оновлення позиції
     */
    async updatePosition(requestParameters: UpdatePositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.updatePositionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Борт, частоти, висота, пілот, телефон, стрім і точка зльоту — те, що не змінюється від вильоту до вильоту й підставляється у форму заявки.
     * Оновлення сталих параметрів вильоту екіпажу
     */
    async updateUavCrewSettingsRaw(requestParameters: UpdateUavCrewSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputUavCrewSettings>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling updateUavCrewSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/uav-crew/settings`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputUavCrewSettingsToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputUavCrewSettingsFromJSON(jsonValue));
    }

    /**
     * Борт, частоти, висота, пілот, телефон, стрім і точка зльоту — те, що не змінюється від вильоту до вильоту й підставляється у форму заявки.
     * Оновлення сталих параметрів вильоту екіпажу
     */
    async updateUavCrewSettings(requestParameters: UpdateUavCrewSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputUavCrewSettings> {
        const response = await this.updateUavCrewSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Правка висоти, швидкості, дати та вікна конкретного вильоту з картки заявки. Швидкість перевизначає ТТХ засобу (анімація борта і прогноз повернення); null у speedKmh повертає розрахунок на ТТХ. Зміна дати або вікна перераховує час актуальності заявки (active/upcoming/history)
     * Параметри вильоту заявки
     */
    async updateUavMissionFlightParamsRaw(requestParameters: UpdateUavMissionFlightParamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateUavMissionFlightParams().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling updateUavMissionFlightParams().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/uav-missions/{id}/flight-params`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: InputUavMissionFlightParamsToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Правка висоти, швидкості, дати та вікна конкретного вильоту з картки заявки. Швидкість перевизначає ТТХ засобу (анімація борта і прогноз повернення); null у speedKmh повертає розрахунок на ТТХ. Зміна дати або вікна перераховує час актуальності заявки (active/upcoming/history)
     * Параметри вильоту заявки
     */
    async updateUavMissionFlightParams(requestParameters: UpdateUavMissionFlightParamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.updateUavMissionFlightParamsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Зберігає точки маршруту та ручний анкер \"за ЛБЗ\"; скидає попередню ручну корекцію позиції літака, оскільки вона прив\'язана до старої геометрії треку
     * Збереження траєкторії польоту (карта)
     */
    async updateUavMissionFlightPathRaw(requestParameters: UpdateUavMissionFlightPathRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateUavMissionFlightPath().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling updateUavMissionFlightPath().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/uav-missions/{id}/flight-path`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputUavMissionFlightPathToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Зберігає точки маршруту та ручний анкер \"за ЛБЗ\"; скидає попередню ручну корекцію позиції літака, оскільки вона прив\'язана до старої геометрії треку
     * Збереження траєкторії польоту (карта)
     */
    async updateUavMissionFlightPath(requestParameters: UpdateUavMissionFlightPathRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.updateUavMissionFlightPathRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Зберігає коло району, в якому розвідник працює до ЛБЗ: центр, радіус та азимут довгої осі петлі. Автоматично район рахує парсер (services.ComputeLoiterArea), цей ендпоінт — ручна правка чергового
     * Збереження району баражування (карта)
     */
    async updateUavMissionLoiterAreaRaw(requestParameters: UpdateUavMissionLoiterAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateUavMissionLoiterArea().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling updateUavMissionLoiterArea().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/uav-missions/{id}/loiter-area`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputUavMissionLoiterAreaToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Зберігає коло району, в якому розвідник працює до ЛБЗ: центр, радіус та азимут довгої осі петлі. Автоматично район рахує парсер (services.ComputeLoiterArea), цей ендпоінт — ручна правка чергового
     * Збереження району баражування (карта)
     */
    async updateUavMissionLoiterArea(requestParameters: UpdateUavMissionLoiterAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.updateUavMissionLoiterAreaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Перетягування маркера літака на мапі: збережена дистанція+напрямок вздовж треку перевизначають розрахунок за часом до наступної зміни статусу
     * Ручна корекція позиції літака
     */
    async updateUavMissionPositionOverrideRaw(requestParameters: UpdateUavMissionPositionOverrideRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateUavMissionPositionOverride().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling updateUavMissionPositionOverride().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/uav-missions/{id}/position-override`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: InputUavMissionPositionOverrideToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Перетягування маркера літака на мапі: збережена дистанція+напрямок вздовж треку перевизначають розрахунок за часом до наступної зміни статусу
     * Ручна корекція позиції літака
     */
    async updateUavMissionPositionOverride(requestParameters: UpdateUavMissionPositionOverrideRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.updateUavMissionPositionOverrideRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Оновлення профілю користувача самим користувачем
     * Оновлення профілю користувача
     */
    async updateUserProfileRaw(requestParameters: UpdateUserProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling updateUserProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/users/profile`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InputUserProfileToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Оновлення профілю користувача самим користувачем
     * Оновлення профілю користувача
     */
    async updateUserProfile(requestParameters: UpdateUserProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUserProfileRaw(requestParameters, initOverrides);
    }

    /**
     * Перевіряє TOTP код для налаштування
     * Верифікація TOTP коду
     */
    async verifyTotpCodeRaw(requestParameters: VerifyTotpCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputTotpVerificationResponse>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling verifyTotpCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/two-factor/totp/verify`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputVerifyTotpCodeRequestToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputTotpVerificationResponseFromJSON(jsonValue));
    }

    /**
     * Перевіряє TOTP код для налаштування
     * Верифікація TOTP коду
     */
    async verifyTotpCode(requestParameters: VerifyTotpCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputTotpVerificationResponse> {
        const response = await this.verifyTotpCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Завершує процес авторизації після успішної 2FA верифікації
     * Верифікація двофакторної авторизації
     */
    async verifyTwoFactorRaw(requestParameters: VerifyTwoFactorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling verifyTwoFactor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/auth/verify-two-factor`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputVerifyTwoFactorRequestToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Завершує процес авторизації після успішної 2FA верифікації
     * Верифікація двофакторної авторизації
     */
    async verifyTwoFactor(requestParameters: VerifyTwoFactorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.verifyTwoFactorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Рахує вітровий профіль довільного треку тим самим кодом, що й бойові заявки (посегментний вітровий трикутник): для кожного сегмента семпить вітер у його середині на обраній висоті, повертає шляхову швидкість з вітром і без, час і підсумкову різницю. Нічого не зберігає
     * Стенд відлагодження впливу вітру на політ
     */
    async windLabRaw(requestParameters: WindLabRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutputWindLabResult>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling windLab().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/system/wind-lab`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputWindLabRequestToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutputWindLabResultFromJSON(jsonValue));
    }

    /**
     * Рахує вітровий профіль довільного треку тим самим кодом, що й бойові заявки (посегментний вітровий трикутник): для кожного сегмента семпить вітер у його середині на обраній висоті, повертає шляхову швидкість з вітром і без, час і підсумкову різницю. Нічого не зберігає
     * Стенд відлагодження впливу вітру на політ
     */
    async windLab(requestParameters: WindLabRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutputWindLabResult> {
        const response = await this.windLabRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Додавання підрозділу до зони, за яку відповідає координатор
     * Додавання підрозділу до зони
     */
    async zoneAdminApproveRequestRaw(requestParameters: ZoneAdminApproveRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling zoneAdminApproveRequest().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling zoneAdminApproveRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/zone-admin/requests/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputZoneAdminZoneToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Додавання підрозділу до зони, за яку відповідає координатор
     * Додавання підрозділу до зони
     */
    async zoneAdminApproveRequest(requestParameters: ZoneAdminApproveRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.zoneAdminApproveRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Створення повідомлення
     */
    async zoneAdminBroadcastCreateNotificationRaw(requestParameters: ZoneAdminBroadcastCreateNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling zoneAdminBroadcastCreateNotification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/zone-admin/broadcast`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputBroadcastRequestToJSON(requestParameters['request']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Створення повідомлення
     */
    async zoneAdminBroadcastCreateNotification(requestParameters: ZoneAdminBroadcastCreateNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.zoneAdminBroadcastCreateNotificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Відхилення заявки на приєдання до зони
     * Відхилення заявки на приєдання до зони
     */
    async zoneAdminDeclineRequestRaw(requestParameters: ZoneAdminDeclineRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling zoneAdminDeclineRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/zone-admin/requests/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Відхилення заявки на приєдання до зони
     * Відхилення заявки на приєдання до зони
     */
    async zoneAdminDeclineRequest(requestParameters: ZoneAdminDeclineRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.zoneAdminDeclineRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Видалення підрозділу з зони, за яку відповідає координатор
     * Видалення підрозділу з зони
     */
    async zoneAdminDeleteDivisionFromZoneRaw(requestParameters: ZoneAdminDeleteDivisionFromZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['divisionId'] == null) {
            throw new runtime.RequiredError(
                'divisionId',
                'Required parameter "divisionId" was null or undefined when calling zoneAdminDeleteDivisionFromZone().'
            );
        }

        if (requestParameters['zoneId'] == null) {
            throw new runtime.RequiredError(
                'zoneId',
                'Required parameter "zoneId" was null or undefined when calling zoneAdminDeleteDivisionFromZone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/zone-admin/division/{divisionId}/zone/{zoneId}`.replace(`{${"divisionId"}}`, encodeURIComponent(String(requestParameters['divisionId']))).replace(`{${"zoneId"}}`, encodeURIComponent(String(requestParameters['zoneId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Видалення підрозділу з зони, за яку відповідає координатор
     * Видалення підрозділу з зони
     */
    async zoneAdminDeleteDivisionFromZone(requestParameters: ZoneAdminDeleteDivisionFromZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.zoneAdminDeleteDivisionFromZoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetAdminBrigadesOrderByEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAdminBrigadesOrderByEnum = typeof GetAdminBrigadesOrderByEnum[keyof typeof GetAdminBrigadesOrderByEnum];
/**
 * @export
 */
export const GetAdminChatsOrderByEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAdminChatsOrderByEnum = typeof GetAdminChatsOrderByEnum[keyof typeof GetAdminChatsOrderByEnum];
/**
 * @export
 */
export const GetAdminDivisionsOrderByEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAdminDivisionsOrderByEnum = typeof GetAdminDivisionsOrderByEnum[keyof typeof GetAdminDivisionsOrderByEnum];
/**
 * @export
 */
export const GetAdminNewsOrderByEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAdminNewsOrderByEnum = typeof GetAdminNewsOrderByEnum[keyof typeof GetAdminNewsOrderByEnum];
/**
 * @export
 */
export const GetAdminOSGsOrderByEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAdminOSGsOrderByEnum = typeof GetAdminOSGsOrderByEnum[keyof typeof GetAdminOSGsOrderByEnum];
/**
 * @export
 */
export const GetAdminOTGsOrderByEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAdminOTGsOrderByEnum = typeof GetAdminOTGsOrderByEnum[keyof typeof GetAdminOTGsOrderByEnum];
/**
 * @export
 */
export const GetAdminSessionsOrderByEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAdminSessionsOrderByEnum = typeof GetAdminSessionsOrderByEnum[keyof typeof GetAdminSessionsOrderByEnum];
/**
 * @export
 */
export const GetAdminStockItemsOrderByEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAdminStockItemsOrderByEnum = typeof GetAdminStockItemsOrderByEnum[keyof typeof GetAdminStockItemsOrderByEnum];
/**
 * @export
 */
export const GetAdminTeamsOrderByEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAdminTeamsOrderByEnum = typeof GetAdminTeamsOrderByEnum[keyof typeof GetAdminTeamsOrderByEnum];
/**
 * @export
 */
export const GetAdminUavPlatformsOrderByEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAdminUavPlatformsOrderByEnum = typeof GetAdminUavPlatformsOrderByEnum[keyof typeof GetAdminUavPlatformsOrderByEnum];
/**
 * @export
 */
export const GetAdminUsersOrderByEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAdminUsersOrderByEnum = typeof GetAdminUsersOrderByEnum[keyof typeof GetAdminUsersOrderByEnum];
/**
 * @export
 */
export const GetAdminZonesOrderByEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAdminZonesOrderByEnum = typeof GetAdminZonesOrderByEnum[keyof typeof GetAdminZonesOrderByEnum];
/**
 * @export
 */
export const GetFlyHistoryOrderByEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetFlyHistoryOrderByEnum = typeof GetFlyHistoryOrderByEnum[keyof typeof GetFlyHistoryOrderByEnum];
/**
 * @export
 */
export const GetPositionsOrderByEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetPositionsOrderByEnum = typeof GetPositionsOrderByEnum[keyof typeof GetPositionsOrderByEnum];
/**
 * @export
 */
export const GetSystemPermissionsOrderByEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetSystemPermissionsOrderByEnum = typeof GetSystemPermissionsOrderByEnum[keyof typeof GetSystemPermissionsOrderByEnum];
/**
 * @export
 */
export const GetTargetsListOrderByEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetTargetsListOrderByEnum = typeof GetTargetsListOrderByEnum[keyof typeof GetTargetsListOrderByEnum];
/**
 * @export
 */
export const GetUavMissionsModeEnum = {
    Active: 'active',
    Upcoming: 'upcoming',
    History: 'history'
} as const;
export type GetUavMissionsModeEnum = typeof GetUavMissionsModeEnum[keyof typeof GetUavMissionsModeEnum];
/**
 * @export
 */
export const GetUavMissionsOrderByEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetUavMissionsOrderByEnum = typeof GetUavMissionsOrderByEnum[keyof typeof GetUavMissionsOrderByEnum];
/**
 * @export
 */
export const GetZoneAdminBroadcastNotificationsListOrderByEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetZoneAdminBroadcastNotificationsListOrderByEnum = typeof GetZoneAdminBroadcastNotificationsListOrderByEnum[keyof typeof GetZoneAdminBroadcastNotificationsListOrderByEnum];
/**
 * @export
 */
export const GetZoneRequestsListOrderByEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetZoneRequestsListOrderByEnum = typeof GetZoneRequestsListOrderByEnum[keyof typeof GetZoneRequestsListOrderByEnum];
